var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polyline, _path10, _polyline2, _path11, _polyline3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 334.36 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-349{fill:none;}.cls-2{fill:#e11a2c;}.cls-3{fill:#231f20;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{clip-path:url(#clip-path);}.cls-14{fill:#1a1a1a;}.cls-15{fill:url(#linear-gradient-10);}.cls-16{fill:url(#linear-gradient-11);}.cls-17{fill:url(#linear-gradient-12);}.cls-18{fill:url(#linear-gradient-13);}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-18);}.cls-24{fill:url(#linear-gradient-19);}.cls-25{fill:url(#linear-gradient-20);}.cls-26{fill:url(#linear-gradient-21);}.cls-27{fill:url(#linear-gradient-22);}.cls-28{fill:url(#linear-gradient-23);}.cls-29{fill:url(#linear-gradient-24);}.cls-30{fill:url(#linear-gradient-25);}.cls-31{fill:url(#linear-gradient-26);}.cls-32{fill:url(#linear-gradient-27);}.cls-33{fill:url(#linear-gradient-28);}.cls-34{fill:url(#linear-gradient-29);}.cls-35{fill:url(#linear-gradient-30);}.cls-36{fill:url(#linear-gradient-31);}.cls-37{fill:url(#linear-gradient-32);}.cls-38{fill:url(#linear-gradient-33);}.cls-39{fill:url(#linear-gradient-34);}.cls-40{fill:url(#linear-gradient-35);}.cls-41{fill:url(#linear-gradient-36);}.cls-42{fill:url(#linear-gradient-37);}.cls-43{fill:url(#linear-gradient-38);}.cls-44{fill:url(#linear-gradient-39);}.cls-45{fill:url(#linear-gradient-40);}.cls-46{fill:url(#linear-gradient-41);}.cls-47{fill:url(#linear-gradient-42);}.cls-48{fill:url(#linear-gradient-43);}.cls-49{fill:url(#linear-gradient-44);}.cls-50{fill:url(#linear-gradient-45);}.cls-51{fill:url(#linear-gradient-46);}.cls-52{fill:url(#linear-gradient-47);}.cls-53{fill:url(#linear-gradient-48);}.cls-54{fill:url(#linear-gradient-49);}.cls-55{fill:url(#linear-gradient-50);}.cls-56{fill:url(#linear-gradient-51);}.cls-57{fill:url(#linear-gradient-53);}.cls-58{fill:url(#linear-gradient-54);}.cls-59{fill:url(#linear-gradient-55);}.cls-60{fill:url(#linear-gradient-56);}.cls-61{fill:url(#linear-gradient-57);}.cls-62{fill:url(#linear-gradient-58);}.cls-63{fill:url(#linear-gradient-59);}.cls-64{fill:url(#linear-gradient-60);}.cls-65{fill:url(#linear-gradient-61);}.cls-66{fill:url(#linear-gradient-62);}.cls-67{fill:url(#linear-gradient-63);}.cls-68{fill:url(#linear-gradient-64);}.cls-69{fill:url(#linear-gradient-65);}.cls-70{fill:url(#linear-gradient-66);}.cls-71{fill:url(#linear-gradient-67);}.cls-72{fill:url(#linear-gradient-68);}.cls-73{fill:url(#linear-gradient-69);}.cls-74{fill:url(#linear-gradient-70);}.cls-75{fill:url(#linear-gradient-71);}.cls-76{fill:url(#linear-gradient-72);}.cls-77{fill:url(#linear-gradient-73);}.cls-78{fill:url(#linear-gradient-74);}.cls-79{fill:url(#linear-gradient-75);}.cls-80{fill:url(#linear-gradient-76);}.cls-81{fill:url(#linear-gradient-77);}.cls-82{fill:url(#linear-gradient-78);}.cls-83{fill:url(#linear-gradient-79);}.cls-84{fill:url(#linear-gradient-80);}.cls-85{fill:url(#linear-gradient-81);}.cls-86{fill:url(#linear-gradient-82);}.cls-87{fill:url(#linear-gradient-83);}.cls-88{fill:url(#linear-gradient-84);}.cls-89{fill:url(#linear-gradient-85);}.cls-90{fill:url(#linear-gradient-86);}.cls-91{fill:url(#linear-gradient-87);}.cls-92{fill:url(#linear-gradient-88);}.cls-93{fill:url(#linear-gradient-89);}.cls-94{fill:url(#linear-gradient-90);}.cls-95{fill:url(#linear-gradient-91);}.cls-96{fill:url(#linear-gradient-92);}.cls-97{fill:#858585;}.cls-98{fill:url(#linear-gradient-93);}.cls-99{fill:url(#linear-gradient-94);}.cls-100{fill:url(#linear-gradient-95);}.cls-101{fill:url(#linear-gradient-96);}.cls-102{fill:url(#linear-gradient-97);}.cls-103{fill:url(#linear-gradient-98);}.cls-104{fill:url(#linear-gradient-99);}.cls-105{fill:url(#linear-gradient-100);}.cls-106{fill:url(#linear-gradient-101);}.cls-107{fill:url(#linear-gradient-102);}.cls-108{fill:url(#linear-gradient-103);}.cls-109{fill:url(#linear-gradient-104);}.cls-110{fill:url(#linear-gradient-105);}.cls-111{fill:url(#linear-gradient-106);}.cls-112{fill:url(#linear-gradient-107);}.cls-113{fill:url(#linear-gradient-108);}.cls-114{fill:url(#linear-gradient-109);}.cls-115{fill:url(#linear-gradient-110);}.cls-116{fill:url(#linear-gradient-111);}.cls-117{fill:url(#linear-gradient-112);}.cls-118{fill:url(#linear-gradient-113);}.cls-119{fill:url(#linear-gradient-114);}.cls-120{fill:url(#linear-gradient-115);}.cls-121{fill:url(#linear-gradient-116);}.cls-122{fill:url(#linear-gradient-117);}.cls-123{fill:url(#linear-gradient-118);}.cls-124{fill:url(#linear-gradient-119);}.cls-125{fill:url(#linear-gradient-120);}.cls-126{fill:url(#linear-gradient-121);}.cls-127{fill:url(#linear-gradient-122);}.cls-128{fill:url(#linear-gradient-123);}.cls-129{fill:url(#linear-gradient-124);}.cls-130{fill:url(#linear-gradient-125);}.cls-131{fill:url(#linear-gradient-126);}.cls-132{fill:url(#linear-gradient-127);}.cls-133{fill:url(#linear-gradient-128);}.cls-134{fill:url(#linear-gradient-129);}.cls-135{fill:url(#linear-gradient-130);}.cls-136{fill:url(#linear-gradient-131);}.cls-137{fill:url(#linear-gradient-132);}.cls-138{fill:url(#linear-gradient-133);}.cls-139{fill:url(#linear-gradient-134);}.cls-140{fill:url(#linear-gradient-135);}.cls-141{fill:url(#linear-gradient-136);}.cls-142{fill:url(#linear-gradient-137);}.cls-143{fill:url(#linear-gradient-138);}.cls-144{fill:url(#linear-gradient-139);}.cls-145{fill:url(#linear-gradient-140);}.cls-146{fill:url(#linear-gradient-141);}.cls-147{fill:url(#linear-gradient-142);}.cls-148{fill:url(#linear-gradient-143);}.cls-149{fill:url(#linear-gradient-144);}.cls-150{fill:url(#linear-gradient-145);}.cls-151{fill:url(#linear-gradient-146);}.cls-152{fill:url(#linear-gradient-147);}.cls-153{fill:url(#linear-gradient-148);}.cls-154{fill:url(#linear-gradient-149);}.cls-155{fill:url(#linear-gradient-150);}.cls-156{fill:url(#linear-gradient-151);}.cls-157{fill:url(#linear-gradient-152);}.cls-158{fill:url(#linear-gradient-153);}.cls-159{fill:url(#linear-gradient-154);}.cls-160{fill:url(#linear-gradient-155);}.cls-161{fill:url(#linear-gradient-156);}.cls-162{fill:url(#linear-gradient-157);}.cls-163{fill:url(#linear-gradient-158);}.cls-164{fill:url(#linear-gradient-159);}.cls-165{fill:url(#linear-gradient-160);}.cls-166{fill:url(#linear-gradient-161);}.cls-167{fill:url(#linear-gradient-162);}.cls-168{fill:url(#linear-gradient-163);}.cls-169{fill:url(#linear-gradient-164);}.cls-170{fill:url(#linear-gradient-165);}.cls-171{fill:url(#linear-gradient-166);}.cls-172{fill:url(#linear-gradient-167);}.cls-173{fill:url(#linear-gradient-168);}.cls-174{fill:url(#linear-gradient-169);}.cls-175{fill:url(#linear-gradient-170);}.cls-176{fill:url(#linear-gradient-171);}.cls-177{fill:url(#linear-gradient-172);}.cls-178{fill:url(#linear-gradient-173);}.cls-179{fill:url(#linear-gradient-174);}.cls-180{fill:url(#linear-gradient-175);}.cls-181{fill:url(#linear-gradient-176);}.cls-182{fill:url(#linear-gradient-177);}.cls-183{fill:url(#linear-gradient-178);}.cls-184{fill:url(#linear-gradient-179);}.cls-185{fill:url(#linear-gradient-180);}.cls-186{fill:url(#linear-gradient-181);}.cls-187{fill:url(#linear-gradient-182);}.cls-188{fill:url(#linear-gradient-183);}.cls-189{fill:url(#linear-gradient-184);}.cls-190{fill:url(#linear-gradient-185);}.cls-191{fill:url(#linear-gradient-186);}.cls-192{fill:url(#linear-gradient-187);}.cls-193{fill:url(#linear-gradient-188);}.cls-194{fill:url(#linear-gradient-189);}.cls-195{fill:url(#linear-gradient-190);}.cls-196{fill:url(#linear-gradient-191);}.cls-197{fill:url(#linear-gradient-192);}.cls-198{fill:url(#linear-gradient-193);}.cls-199{fill:url(#linear-gradient-194);}.cls-200{fill:url(#linear-gradient-195);}.cls-201{fill:url(#linear-gradient-196);}.cls-202{fill:url(#linear-gradient-197);}.cls-203{fill:url(#linear-gradient-198);}.cls-204{fill:url(#linear-gradient-199);}.cls-205{fill:url(#linear-gradient-200);}.cls-206{fill:url(#linear-gradient-201);}.cls-207{fill:url(#linear-gradient-202);}.cls-208{fill:url(#linear-gradient-203);}.cls-209{fill:url(#linear-gradient-204);}.cls-210{fill:url(#linear-gradient-205);}.cls-211{fill:url(#linear-gradient-206);}.cls-212{fill:url(#linear-gradient-207);}.cls-213{fill:url(#linear-gradient-208);}.cls-214{fill:url(#linear-gradient-209);}.cls-215{fill:url(#linear-gradient-210);}.cls-216{fill:url(#linear-gradient-211);}.cls-217{fill:url(#linear-gradient-212);}.cls-218{fill:url(#linear-gradient-213);}.cls-219{fill:url(#linear-gradient-214);}.cls-220{fill:url(#linear-gradient-215);}.cls-221{fill:url(#linear-gradient-217);}.cls-222{fill:url(#linear-gradient-218);}.cls-223{fill:url(#linear-gradient-219);}.cls-224{fill:url(#linear-gradient-220);}.cls-225{fill:url(#linear-gradient-221);}.cls-226{fill:url(#linear-gradient-222);}.cls-227{fill:url(#linear-gradient-223);}.cls-228{fill:url(#linear-gradient-224);}.cls-229{fill:url(#linear-gradient-225);}.cls-230{fill:url(#linear-gradient-226);}.cls-231{fill:url(#linear-gradient-227);}.cls-232{fill:url(#linear-gradient-228);}.cls-233{fill:url(#linear-gradient-229);}.cls-234{fill:url(#linear-gradient-230);}.cls-235{fill:url(#linear-gradient-231);}.cls-236{fill:url(#linear-gradient-232);}.cls-237{fill:url(#linear-gradient-233);}.cls-238{fill:url(#linear-gradient-234);}.cls-239{fill:url(#linear-gradient-235);}.cls-240{fill:url(#linear-gradient-236);}.cls-241{fill:url(#linear-gradient-237);}.cls-242{fill:url(#linear-gradient-238);}.cls-243{fill:url(#linear-gradient-239);}.cls-244{fill:url(#linear-gradient-240);}.cls-245{fill:url(#linear-gradient-241);}.cls-246{fill:url(#linear-gradient-242);}.cls-247{fill:url(#linear-gradient-243);}.cls-248{fill:url(#linear-gradient-244);}.cls-249{fill:url(#linear-gradient-245);}.cls-250{fill:url(#linear-gradient-246);}.cls-251{fill:url(#linear-gradient-247);}.cls-252{fill:url(#linear-gradient-248);}.cls-253{fill:url(#linear-gradient-249);}.cls-254{fill:url(#linear-gradient-250);}.cls-255{fill:url(#linear-gradient-251);}.cls-256{fill:url(#linear-gradient-252);}.cls-257{fill:url(#linear-gradient-253);}.cls-258{fill:url(#linear-gradient-254);}.cls-259{fill:url(#linear-gradient-255);}.cls-260{fill:url(#linear-gradient-256);}.cls-261{fill:url(#linear-gradient-257);}.cls-262{fill:url(#linear-gradient-258);}.cls-263{fill:url(#linear-gradient-259);}.cls-264{fill:url(#linear-gradient-260);}.cls-265{fill:url(#linear-gradient-261);}.cls-266{fill:url(#linear-gradient-262);}.cls-267{fill:url(#linear-gradient-263);}.cls-268{fill:url(#linear-gradient-264);}.cls-269{fill:url(#linear-gradient-265);}.cls-270{fill:url(#linear-gradient-266);}.cls-271{fill:url(#linear-gradient-267);}.cls-272{fill:url(#linear-gradient-268);}.cls-273{fill:url(#linear-gradient-269);}.cls-274{fill:url(#linear-gradient-270);}.cls-275{fill:url(#linear-gradient-271);}.cls-276{fill:url(#linear-gradient-272);}.cls-277{fill:url(#linear-gradient-273);}.cls-278{fill:url(#linear-gradient-274);}.cls-279{fill:url(#linear-gradient-275);}.cls-280{fill:url(#linear-gradient-276);}.cls-281{fill:url(#linear-gradient-277);}.cls-282{fill:url(#linear-gradient-278);}.cls-283{fill:url(#linear-gradient-279);}.cls-284{fill:url(#linear-gradient-280);}.cls-285{fill:url(#linear-gradient-281);}.cls-286{fill:url(#linear-gradient-282);}.cls-287{fill:url(#linear-gradient-283);}.cls-288{fill:url(#linear-gradient-284);}.cls-289{fill:url(#linear-gradient-285);}.cls-290{fill:url(#linear-gradient-286);}.cls-291{fill:url(#linear-gradient-287);}.cls-292{fill:url(#linear-gradient-288);}.cls-293{fill:url(#linear-gradient-289);}.cls-294{fill:url(#linear-gradient-290);}.cls-295{fill:url(#linear-gradient-291);}.cls-296{fill:url(#linear-gradient-292);}.cls-297{fill:url(#linear-gradient-293);}.cls-298{fill:url(#linear-gradient-294);}.cls-299{fill:url(#linear-gradient-295);}.cls-300{fill:url(#linear-gradient-296);}.cls-301{fill:url(#linear-gradient-297);}.cls-302{fill:url(#linear-gradient-298);}.cls-303{fill:url(#linear-gradient-299);}.cls-304{fill:url(#linear-gradient-300);}.cls-305{fill:url(#linear-gradient-301);}.cls-306{fill:url(#linear-gradient-302);}.cls-307{fill:url(#linear-gradient-303);}.cls-308{fill:url(#linear-gradient-304);}.cls-309{fill:url(#linear-gradient-305);}.cls-310{fill:url(#linear-gradient-306);}.cls-311{fill:url(#linear-gradient-307);}.cls-312{fill:url(#linear-gradient-308);}.cls-313{fill:url(#linear-gradient-309);}.cls-314{fill:url(#linear-gradient-310);}.cls-315{fill:url(#linear-gradient-311);}.cls-316{fill:url(#linear-gradient-312);}.cls-317{fill:url(#linear-gradient-313);}.cls-318{fill:url(#linear-gradient-314);}.cls-319{fill:url(#linear-gradient-315);}.cls-320{fill:url(#linear-gradient-316);}.cls-321{fill:url(#linear-gradient-317);}.cls-322{fill:url(#linear-gradient-318);}.cls-323{fill:url(#linear-gradient-319);}.cls-324{fill:url(#linear-gradient-320);}.cls-325{fill:url(#linear-gradient-321);}.cls-326{fill:url(#linear-gradient-322);}.cls-327{fill:url(#linear-gradient-323);}.cls-328{fill:url(#linear-gradient-324);}.cls-329{fill:url(#linear-gradient-325);}.cls-330{fill:url(#linear-gradient-326);}.cls-331{fill:url(#linear-gradient-327);}.cls-332{fill:url(#linear-gradient-328);}.cls-333{fill:url(#linear-gradient-329);}.cls-334{fill:url(#linear-gradient-330);}.cls-335{fill:url(#linear-gradient-331);}.cls-336{fill:url(#linear-gradient-332);}.cls-337{fill:url(#linear-gradient-333);}.cls-338{fill:url(#linear-gradient-334);}.cls-339{fill:url(#linear-gradient-335);}.cls-340{fill:url(#linear-gradient-336);}.cls-341{fill:url(#linear-gradient-337);}.cls-342{fill:url(#linear-gradient-338);}.cls-343{fill:url(#linear-gradient-339);}.cls-344{fill:url(#linear-gradient-340);}.cls-345{fill:url(#linear-gradient-341);}.cls-346{fill:#f2f2f2;}.cls-347{fill:#fff;}.cls-348{fill:#636666;}.cls-349{stroke:#636666;stroke-miterlimit:10;stroke-width:0.5px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 300.52,
    y1: 35.53,
    x2: 281.24,
    y2: 13.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 308.45,
    y1: 35.53,
    x2: 327.73,
    y2: 13.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 304.49,
    y1: 14.19,
    x2: 304.49,
    y2: 2.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 284.93,
    y1: 14.06,
    x2: 324.04,
    y2: 14.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 300.93,
    y1: 10.35,
    x2: 308.04,
    y2: 10.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 304.49,
    y1: 2.67,
    x2: 304.49,
    y2: 22.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 307.84,
    y1: 16.5,
    x2: 307.84,
    y2: 33.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2b2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 300.79,
    y1: 22.54,
    x2: 308.19,
    y2: 22.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 301.13,
    y1: 16.5,
    x2: 301.13,
    y2: 33.06,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.49.57c-14.86,0-25.4,7.25-25.4,17.36s11.37,17.36,25.4,17.36,25.39-7.24,25.39-17.36S319.34.57,304.49.57Zm0,2.1c6.73,0,16.8,2.43,16.8,6.21,0,2-3.08,4.33-11.09,5.08a23.44,23.44,0,0,0-2.06-7.77c-1-2-2.11-3.09-3.61-3.09s-2.65,1.13-3.65,3.1a23.38,23.38,0,0,0-2.1,7.76c-8-.74-11.09-3.05-11.09-5.08C287.69,5.1,297.75,2.67,304.49,2.67Zm0,11.52c-1.27,0-2.45,0-3.56-.08.45-4.35,1.87-7.52,3.56-7.52s3.1,3.17,3.55,7.52C306.94,14.16,305.75,14.19,304.49,14.19Zm3.7,3.19c-.07,5.62-1.83,10.32-3.7,10.32s-3.63-4.7-3.7-10.32c1.16.08,2.4.12,3.7.12S307,17.46,308.19,17.38ZM304.49,33c-12.83,0-22.28-6.6-22.28-15.11a13.38,13.38,0,0,1,3-8.25,3.64,3.64,0,0,0,0,.56c0,2.58,4.27,5.93,13.44,7,0,.1,0,.2,0,.3,0,8.38,2.64,15.17,5.9,15.17s5.89-6.79,5.89-15.17v-.3c9.16-1,13.43-4.38,13.43-7a5.46,5.46,0,0,0,0-.56,13.44,13.44,0,0,1,3,8.25C326.77,26.43,317.31,33,304.49,33Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 304.49,
    y1: 0.52,
    x2: 304.49,
    y2: 38.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 304.49,
    y1: 0.53,
    x2: 304.49,
    y2: 38.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 304.49,
    y1: 0.54,
    x2: 304.49,
    y2: 38.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2b2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 304.49,
    y1: 0.55,
    x2: 304.49,
    y2: 38.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 304.49,
    y1: 0.56,
    x2: 304.49,
    y2: 38.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 304.49,
    y1: 0.57,
    x2: 304.49,
    y2: 38.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d3d3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 304.49,
    y1: 0.58,
    x2: 304.49,
    y2: 38.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 304.49,
    y1: 0.59,
    x2: 304.49,
    y2: 38.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 304.49,
    y1: 0.6,
    x2: 304.49,
    y2: 38.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4f4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 304.49,
    y1: 0.61,
    x2: 304.49,
    y2: 38.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 304.49,
    y1: 0.62,
    x2: 304.49,
    y2: 38.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5b5b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 304.49,
    y1: 0.63,
    x2: 304.49,
    y2: 38.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 304.49,
    y1: 0.64,
    x2: 304.49,
    y2: 38.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 304.49,
    y1: 0.65,
    x2: 304.49,
    y2: 38.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6d6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 304.49,
    y1: 0.66,
    x2: 304.49,
    y2: 38.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 304.49,
    y1: 0.67,
    x2: 304.49,
    y2: 38.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 304.49,
    y1: 0.68,
    x2: 304.49,
    y2: 38.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#acacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f7f7f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 304.49,
    y1: 0.69,
    x2: 304.49,
    y2: 38.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 304.49,
    y1: 0.7,
    x2: 304.49,
    y2: 38.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "silver"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 304.49,
    y1: 0.71,
    x2: 304.49,
    y2: 38.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#cacaca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 304.49,
    y1: 0.72,
    x2: 304.49,
    y2: 38.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 304.49,
    y1: 0.73,
    x2: 304.49,
    y2: 37.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#dcddde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#d3d5d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c0c2c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 304.49,
    y1: 0.74,
    x2: 304.49,
    y2: 37.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dedfe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dedfe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d6d8d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#d0d1d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#bbbdbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d8d8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 304.49,
    y1: 0.75,
    x2: 304.49,
    y2: 37.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d9db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d8d9db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d0d2d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#cdced0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#b6b8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 304.49,
    y1: 0.76,
    x2: 304.49,
    y2: 37.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d3d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d2d3d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#cbccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#cacbcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#b1b3b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 304.49,
    y1: 0.77,
    x2: 304.49,
    y2: 37.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccdcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cccdcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#c5c7c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c6c8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#acaeb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f7f7f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 304.49,
    y1: 0.78,
    x2: 304.49,
    y2: 37.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c7c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c6c7c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#bfc1c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c3c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a7a7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 304.49,
    y1: 0.8,
    x2: 304.49,
    y2: 37.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfc1c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bfc1c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#b9bbbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c0c2c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#a2a4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 304.49,
    y1: 0.81,
    x2: 304.49,
    y2: 36.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#b4b6b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#bdbfc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9d9fa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 304.49,
    y1: 0.82,
    x2: 304.49,
    y2: 36.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#aeb0b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#babcbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#999b9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c6c6c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 304.49,
    y1: 0.83,
    x2: 304.49,
    y2: 36.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adafb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#adafb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a9abad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#b7b9bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#949699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 304.49,
    y1: 0.84,
    x2: 304.49,
    y2: 36.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a3a5a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8f9194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#626262"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 304.49,
    y1: 0.85,
    x2: 304.49,
    y2: 36.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1a3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#a1a3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9ea0a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#b0b2b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8b8d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e5e5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 304.49,
    y1: 0.86,
    x2: 304.49,
    y2: 36.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c9ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9c9ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#989a9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#adafb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#86888b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 304.49,
    y1: 0.87,
    x2: 304.49,
    y2: 36.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#96989b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#aaacaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#828486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 304.49,
    y1: 0.88,
    x2: 304.49,
    y2: 35.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#909295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#909295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#8e9093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7d7f82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4f4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 304.49,
    y1: 0.9,
    x2: 304.49,
    y2: 35.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b8d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8b8d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#898b8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a4a6a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#797a7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 304.49,
    y1: 0.91,
    x2: 304.49,
    y2: 35.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85878a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#85878a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#848688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#a1a3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#747678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464646"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 304.49,
    y1: 0.92,
    x2: 304.49,
    y2: 35.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#808284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7f8083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9ea0a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6f7173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414141"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 304.49,
    y1: 0.93,
    x2: 304.49,
    y2: 35.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a7c7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7a7c7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#797b7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9b9da0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6b6c6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 304.49,
    y1: 0.94,
    x2: 304.49,
    y2: 35.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#757679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#747678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#989a9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#666769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 304.49,
    y1: 0.95,
    x2: 304.49,
    y2: 34.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 304.47,
    y1: 0.96,
    x2: 304.47,
    y2: 34.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 304.46,
    y1: 0.97,
    x2: 304.46,
    y2: 34.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 304.44,
    y1: 0.98,
    x2: 304.44,
    y2: 34.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 304.42,
    y1: 0.98,
    x2: 304.42,
    y2: 34.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b3b3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 304.41,
    y1: 0.99,
    x2: 304.41,
    y2: 34.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d3d3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 304.39,
    y1: 1,
    x2: 304.39,
    y2: 34.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 304.38,
    y1: 1.01,
    x2: 304.38,
    y2: 34.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414141"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 304.36,
    y1: 1.02,
    x2: 304.36,
    y2: 34.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 304.35,
    y1: 1.03,
    x2: 304.35,
    y2: 34.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 304.33,
    y1: 1.04,
    x2: 304.33,
    y2: 34.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 304.31,
    y1: 1.05,
    x2: 304.31,
    y2: 34.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 304.3,
    y1: 1.05,
    x2: 304.3,
    y2: 34.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 304.28,
    y1: 1.06,
    x2: 304.28,
    y2: 34.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 304.27,
    y1: 1.07,
    x2: 304.27,
    y2: 34.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4f4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 304.25,
    y1: 1.08,
    x2: 304.25,
    y2: 34.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 304.24,
    y1: 1.09,
    x2: 304.24,
    y2: 34.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 304.22,
    y1: 1.1,
    x2: 304.22,
    y2: 34.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 304.21,
    y1: 1.11,
    x2: 304.21,
    y2: 34.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 304.19,
    y1: 1.11,
    x2: 304.19,
    y2: 34.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 304.17,
    y1: 1.12,
    x2: 304.17,
    y2: 34.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5b5b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 304.16,
    y1: 1.13,
    x2: 304.16,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d5d5d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 304.14,
    y1: 1.14,
    x2: 304.14,
    y2: 33.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f5f5f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 304.13,
    y1: 1.15,
    x2: 304.13,
    y2: 33.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 304.11,
    y1: 1.16,
    x2: 304.11,
    y2: 33.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 304.1,
    y1: 1.17,
    x2: 304.1,
    y2: 33.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 304.08,
    y1: 1.18,
    x2: 304.08,
    y2: 33.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 304.07,
    y1: 1.18,
    x2: 304.07,
    y2: 33.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6c6c6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 304.05,
    y1: 1.19,
    x2: 304.05,
    y2: 33.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 304.03,
    y1: 1.2,
    x2: 304.03,
    y2: 33.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6d6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 304.02,
    y1: 1.21,
    x2: 304.02,
    y2: 33.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f6f6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 304,
    y1: 1.22,
    x2: 304,
    y2: 33.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 303.99,
    y1: 1.23,
    x2: 303.99,
    y2: 33.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 303.97,
    y1: 1.24,
    x2: 303.97,
    y2: 33.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 303.96,
    y1: 1.25,
    x2: 303.96,
    y2: 33.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7b7b7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 303.94,
    y1: 1.26,
    x2: 303.94,
    y2: 33.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 303.92,
    y1: 1.26,
    x2: 303.92,
    y2: 33.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b7b7b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 303.91,
    y1: 1.27,
    x2: 303.91,
    y2: 33.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 303.89,
    y1: 1.28,
    x2: 303.89,
    y2: 33.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f7f7f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 303.88,
    y1: 1.29,
    x2: 303.88,
    y2: 33.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#828282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 303.86,
    y1: 1.3,
    x2: 303.86,
    y2: 33.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 290.94,
    y1: 3.96,
    x2: 317.18,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 290.95,
    y1: 3.96,
    x2: 317.17,
    y2: 30.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#858585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 290.96,
    y1: 3.97,
    x2: 317.17,
    y2: 30.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 290.98,
    y1: 3.98,
    x2: 317.16,
    y2: 30.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 290.99,
    y1: 3.99,
    x2: 317.16,
    y2: 30.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 291,
    y1: 3.99,
    x2: 317.15,
    y2: 30.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 291.02,
    y1: 4,
    x2: 317.15,
    y2: 30.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 291.03,
    y1: 4.01,
    x2: 317.14,
    y2: 30.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 291.04,
    y1: 4.02,
    x2: 317.14,
    y2: 30.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 291.06,
    y1: 4.03,
    x2: 317.13,
    y2: 30.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 291.07,
    y1: 4.03,
    x2: 317.13,
    y2: 30.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#898989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 291.08,
    y1: 4.04,
    x2: 317.12,
    y2: 30.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#898989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 291.09,
    y1: 4.05,
    x2: 317.12,
    y2: 30.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#898989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 291.11,
    y1: 4.06,
    x2: 317.11,
    y2: 30.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a8a8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 291.12,
    y1: 4.06,
    x2: 317.11,
    y2: 30.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a8a8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 291.13,
    y1: 4.07,
    x2: 317.1,
    y2: 30.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 291.15,
    y1: 4.08,
    x2: 317.1,
    y2: 30.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 291.16,
    y1: 4.09,
    x2: 317.09,
    y2: 30.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b8b8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 291.17,
    y1: 4.1,
    x2: 317.09,
    y2: 30.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 291.19,
    y1: 4.1,
    x2: 317.08,
    y2: 30.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 291.2,
    y1: 4.11,
    x2: 317.08,
    y2: 30.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 291.21,
    y1: 4.12,
    x2: 317.07,
    y2: 30.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d8d8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 291.22,
    y1: 4.13,
    x2: 317.07,
    y2: 30.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d8d8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 291.24,
    y1: 4.14,
    x2: 317.06,
    y2: 30.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 291.25,
    y1: 4.14,
    x2: 317.06,
    y2: 30.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 291.26,
    y1: 4.15,
    x2: 317.05,
    y2: 30.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 291.28,
    y1: 4.16,
    x2: 317.05,
    y2: 30.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f8f8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 291.29,
    y1: 4.17,
    x2: 317.04,
    y2: 30.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f8f8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 291.3,
    y1: 4.17,
    x2: 317.04,
    y2: 30.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f8f8f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 291.32,
    y1: 4.18,
    x2: 317.03,
    y2: 30.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 291.33,
    y1: 4.19,
    x2: 317.03,
    y2: 30.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 291.34,
    y1: 4.2,
    x2: 317.02,
    y2: 30.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 291.35,
    y1: 4.21,
    x2: 317.02,
    y2: 30.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 291.37,
    y1: 4.21,
    x2: 317.01,
    y2: 30.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ababab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 291.38,
    y1: 4.22,
    x2: 317.01,
    y2: 30.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#acacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 291.39,
    y1: 4.23,
    x2: 317,
    y2: 30.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 291.41,
    y1: 4.24,
    x2: 317,
    y2: 30.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aeaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929292"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 291.42,
    y1: 4.24,
    x2: 316.99,
    y2: 30.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 291.43,
    y1: 4.25,
    x2: 316.99,
    y2: 30.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 291.45,
    y1: 4.26,
    x2: 316.98,
    y2: 30.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 291.46,
    y1: 4.27,
    x2: 316.98,
    y2: 30.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 291.55,
    y1: 4.21,
    x2: 316.8,
    y2: 30.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdbfc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 291.63,
    y1: 4.15,
    x2: 316.62,
    y2: 30.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdbfc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bdbfc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 291.72,
    y1: 4.09,
    x2: 316.44,
    y2: 30.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bec0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 291.81,
    y1: 4.04,
    x2: 316.26,
    y2: 30.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfc1c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bfc0c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 291.9,
    y1: 3.98,
    x2: 316.08,
    y2: 30.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0c1c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bfc1c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 291.99,
    y1: 3.92,
    x2: 315.9,
    y2: 30.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0c2c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c0c2c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 292.08,
    y1: 3.87,
    x2: 315.72,
    y2: 30.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1c3c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1c3c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 292.17,
    y1: 3.81,
    x2: 315.55,
    y2: 30.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2c4c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c1c3c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 292.26,
    y1: 3.76,
    x2: 315.37,
    y2: 30.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2c4c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c2c4c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 292.35,
    y1: 3.71,
    x2: 315.2,
    y2: 30.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c3c5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 292.44,
    y1: 3.66,
    x2: 315.03,
    y2: 30.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4c6c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c4c5c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 292.53,
    y1: 3.61,
    x2: 314.86,
    y2: 30.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5c6c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c4c6c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 292.62,
    y1: 3.57,
    x2: 314.69,
    y2: 30.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5c7c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c5c7c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 292.71,
    y1: 3.52,
    x2: 314.52,
    y2: 29.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c6c8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 292.8,
    y1: 3.48,
    x2: 314.35,
    y2: 29.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7c9ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c7c8ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 292.89,
    y1: 3.43,
    x2: 314.18,
    y2: 29.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c9cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c7c9cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 292.98,
    y1: 3.38,
    x2: 314.01,
    y2: 29.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 293.08,
    y1: 3.34,
    x2: 313.85,
    y2: 29.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9cbcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c9cbcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 293.17,
    y1: 3.3,
    x2: 313.69,
    y2: 29.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacbcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cacbcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 293.26,
    y1: 3.26,
    x2: 313.52,
    y2: 29.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#caccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#caccce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 293.35,
    y1: 3.22,
    x2: 313.36,
    y2: 29.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbcdcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cbcdce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 293.44,
    y1: 3.18,
    x2: 313.2,
    y2: 29.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cccdcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cccdcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 293.54,
    y1: 3.14,
    x2: 313.04,
    y2: 29.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdced0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ccced0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 293.63,
    y1: 3.11,
    x2: 312.88,
    y2: 29.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdcfd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cdcfd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 293.72,
    y1: 3.07,
    x2: 312.73,
    y2: 29.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ced0d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cecfd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 293.81,
    y1: 3.04,
    x2: 312.57,
    y2: 29.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfd0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cfd0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 293.9,
    y1: 3,
    x2: 312.42,
    y2: 29.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0d1d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cfd1d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 294,
    y1: 2.97,
    x2: 312.26,
    y2: 29.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d0d2d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 294.09,
    y1: 2.94,
    x2: 312.11,
    y2: 29.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d2d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d1d2d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 294.18,
    y1: 2.91,
    x2: 311.96,
    y2: 29.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d3d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d2d3d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 294.27,
    y1: 2.88,
    x2: 311.81,
    y2: 28.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 294.37,
    y1: 2.85,
    x2: 311.66,
    y2: 28.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3d5d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d3d4d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 294.46,
    y1: 2.82,
    x2: 311.51,
    y2: 28.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d4d5d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 294.55,
    y1: 2.79,
    x2: 311.36,
    y2: 28.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5d6d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d5d6d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 294.64,
    y1: 2.77,
    x2: 311.22,
    y2: 28.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5d7d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d5d7d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 294.73,
    y1: 2.74,
    x2: 311.07,
    y2: 28.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6d7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d6d7d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 294.83,
    y1: 2.72,
    x2: 310.93,
    y2: 28.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d8da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d7d8d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 294.92,
    y1: 2.69,
    x2: 310.79,
    y2: 28.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d9da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d7d9da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 295.01,
    y1: 2.67,
    x2: 310.64,
    y2: 28.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d9db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d8d9db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 295.1,
    y1: 2.65,
    x2: 310.5,
    y2: 28.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9dadc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9dadc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 295.19,
    y1: 2.63,
    x2: 310.36,
    y2: 28.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 295.2,
    y1: 2.64,
    x2: 310.36,
    y2: 28.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dadbdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dadbdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 295.2,
    y1: 2.65,
    x2: 310.35,
    y2: 28.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dadcdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dadcdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 295.21,
    y1: 2.66,
    x2: 310.34,
    y2: 28.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 295.21,
    y1: 2.67,
    x2: 310.33,
    y2: 28.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbdcde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdcde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 295.22,
    y1: 2.68,
    x2: 310.32,
    y2: 28.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbddde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbddde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 295.22,
    y1: 2.69,
    x2: 310.32,
    y2: 28.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcddde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dcddde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 295.23,
    y1: 2.7,
    x2: 310.31,
    y2: 28.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcdddf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dcddde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 295.23,
    y1: 2.71,
    x2: 310.3,
    y2: 28.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dcdedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 295.24,
    y1: 2.72,
    x2: 310.29,
    y2: 28.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 295.24,
    y1: 2.73,
    x2: 310.28,
    y2: 28.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dddee0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 295.25,
    y1: 2.75,
    x2: 310.27,
    y2: 28.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dedfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dddee0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 295.26,
    y1: 2.76,
    x2: 310.27,
    y2: 28.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dedfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dedfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 295.26,
    y1: 2.77,
    x2: 310.26,
    y2: 28.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dedfe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dedfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 295.27,
    y1: 2.78,
    x2: 310.25,
    y2: 28.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dedfe1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 295.27,
    y1: 2.79,
    x2: 310.24,
    y2: 28.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 295.28,
    y1: 2.8,
    x2: 310.23,
    y2: 28.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfe0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 295.28,
    y1: 2.81,
    x2: 310.22,
    y2: 28.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dfe0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 295.29,
    y1: 2.82,
    x2: 310.22,
    y2: 28.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e0e1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 295.29,
    y1: 2.83,
    x2: 310.21,
    y2: 28.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e1e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e0e1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 295.3,
    y1: 2.84,
    x2: 310.2,
    y2: 28.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e0e1e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 295.3,
    y1: 2.85,
    x2: 310.19,
    y2: 28.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e1e2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 295.31,
    y1: 2.86,
    x2: 310.18,
    y2: 28.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2e3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e1e2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 295.31,
    y1: 2.87,
    x2: 310.17,
    y2: 27.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2e3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e1e2e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 295.32,
    y1: 2.88,
    x2: 310.17,
    y2: 27.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2e3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e2e3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 295.32,
    y1: 2.89,
    x2: 310.16,
    y2: 27.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e2e3e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 295.33,
    y1: 2.9,
    x2: 310.15,
    y2: 27.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 295.33,
    y1: 2.91,
    x2: 310.14,
    y2: 27.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e3e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 295.34,
    y1: 2.92,
    x2: 310.13,
    y2: 27.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e3e4e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 295.34,
    y1: 2.93,
    x2: 310.12,
    y2: 27.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e4e4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 295.35,
    y1: 2.94,
    x2: 310.12,
    y2: 27.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 295.35,
    y1: 2.95,
    x2: 310.11,
    y2: 27.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e6e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e4e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 295.36,
    y1: 2.97,
    x2: 310.1,
    y2: 27.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e6e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e5e5e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 295.37,
    y1: 2.98,
    x2: 310.09,
    y2: 27.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e5e6e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 295.37,
    y1: 2.99,
    x2: 310.08,
    y2: 27.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e5e6e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 295.38,
    y1: 3,
    x2: 310.08,
    y2: 27.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e6e6e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 295.38,
    y1: 3.01,
    x2: 310.07,
    y2: 27.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 295.39,
    y1: 3.02,
    x2: 310.06,
    y2: 27.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 295.39,
    y1: 3.03,
    x2: 310.05,
    y2: 27.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e7e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 295.4,
    y1: 3.04,
    x2: 310.04,
    y2: 27.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 295.4,
    y1: 3.05,
    x2: 310.03,
    y2: 27.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e7e8e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 295.41,
    y1: 3.06,
    x2: 310.02,
    y2: 27.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 295.39,
    y1: 3.11,
    x2: 309.96,
    y2: 27.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 295.38,
    y1: 3.16,
    x2: 309.89,
    y2: 27.69,
    xlinkHref: "#linear-gradient-217"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 295.36,
    y1: 3.21,
    x2: 309.82,
    y2: 27.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 295.35,
    y1: 3.26,
    x2: 309.75,
    y2: 27.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c9c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 295.33,
    y1: 3.31,
    x2: 309.68,
    y2: 27.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d9d9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 295.31,
    y1: 3.36,
    x2: 309.61,
    y2: 27.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d9d9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 295.3,
    y1: 3.41,
    x2: 309.54,
    y2: 27.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e9e9e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 295.28,
    y1: 3.46,
    x2: 309.47,
    y2: 27.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f9f9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 295.27,
    y1: 3.51,
    x2: 309.4,
    y2: 27.39,
    xlinkHref: "#linear-gradient-224"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 295.25,
    y1: 3.55,
    x2: 309.33,
    y2: 27.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0a0a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 295.23,
    y1: 3.6,
    x2: 309.26,
    y2: 27.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1a1a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 295.22,
    y1: 3.65,
    x2: 309.19,
    y2: 27.27,
    xlinkHref: "#linear-gradient-227"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 295.2,
    y1: 3.7,
    x2: 309.12,
    y2: 27.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2a2a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 295.19,
    y1: 3.75,
    x2: 309.05,
    y2: 27.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a3a3a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 295.17,
    y1: 3.8,
    x2: 308.98,
    y2: 27.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4a4a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 295.15,
    y1: 3.85,
    x2: 308.91,
    y2: 27.1,
    xlinkHref: "#linear-gradient-231"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 295.14,
    y1: 3.9,
    x2: 308.84,
    y2: 27.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5a5a5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 295.12,
    y1: 3.95,
    x2: 308.77,
    y2: 27.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 295.11,
    y1: 4,
    x2: 308.7,
    y2: 26.98,
    xlinkHref: "#linear-gradient-234"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 295.09,
    y1: 4.05,
    x2: 308.63,
    y2: 26.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 295.08,
    y1: 4.1,
    x2: 308.56,
    y2: 26.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 295.06,
    y1: 4.15,
    x2: 308.49,
    y2: 26.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a9a9a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 295.04,
    y1: 4.2,
    x2: 308.42,
    y2: 26.81,
    xlinkHref: "#linear-gradient-238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 295.03,
    y1: 4.25,
    x2: 308.35,
    y2: 26.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aaa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 295.01,
    y1: 4.3,
    x2: 308.28,
    y2: 26.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ababab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 295,
    y1: 4.35,
    x2: 308.21,
    y2: 26.69,
    xlinkHref: "#linear-gradient-241"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 294.98,
    y1: 4.4,
    x2: 308.14,
    y2: 26.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#acacac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 294.97,
    y1: 4.45,
    x2: 308.08,
    y2: 26.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adadad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 294.95,
    y1: 4.5,
    x2: 308,
    y2: 26.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aeaeae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 294.93,
    y1: 4.54,
    x2: 307.94,
    y2: 26.52,
    xlinkHref: "#linear-gradient-245"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 294.92,
    y1: 4.59,
    x2: 307.87,
    y2: 26.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afafaf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 294.9,
    y1: 4.64,
    x2: 307.8,
    y2: 26.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 294.89,
    y1: 4.69,
    x2: 307.73,
    y2: 26.4,
    xlinkHref: "#linear-gradient-248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 294.87,
    y1: 4.74,
    x2: 307.66,
    y2: 26.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b1b1b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 294.85,
    y1: 4.79,
    x2: 307.59,
    y2: 26.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 294.84,
    y1: 4.84,
    x2: 307.52,
    y2: 26.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 294.82,
    y1: 4.89,
    x2: 307.45,
    y2: 26.23,
    xlinkHref: "#linear-gradient-252"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 294.81,
    y1: 4.94,
    x2: 307.38,
    y2: 26.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4b4b4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 294.79,
    y1: 4.99,
    x2: 307.31,
    y2: 26.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 294.78,
    y1: 5.04,
    x2: 307.24,
    y2: 26.11,
    xlinkHref: "#linear-gradient-255"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: 294.76,
    y1: 5.09,
    x2: 307.17,
    y2: 26.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6b6b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 294.74,
    y1: 5.14,
    x2: 307.1,
    y2: 26.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7b7b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: 294.73,
    y1: 5.19,
    x2: 307.03,
    y2: 25.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7b7b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 294.71,
    y1: 5.24,
    x2: 306.96,
    y2: 25.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b8b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 294.7,
    y1: 5.29,
    x2: 306.89,
    y2: 25.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9b9b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 294.68,
    y1: 5.34,
    x2: 306.82,
    y2: 25.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bababa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 294.66,
    y1: 5.39,
    x2: 306.75,
    y2: 25.82,
    xlinkHref: "#linear-gradient-262"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 294.65,
    y1: 5.43,
    x2: 306.68,
    y2: 25.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: 294.63,
    y1: 5.48,
    x2: 306.61,
    y2: 25.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbcbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: 294.62,
    y1: 5.53,
    x2: 306.54,
    y2: 25.7,
    xlinkHref: "#linear-gradient-265"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: 294.6,
    y1: 5.58,
    x2: 306.47,
    y2: 25.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdbdbd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: 294.59,
    y1: 5.63,
    x2: 306.41,
    y2: 25.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: 294.57,
    y1: 5.68,
    x2: 306.34,
    y2: 25.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 294.55,
    y1: 5.73,
    x2: 306.27,
    y2: 25.53,
    xlinkHref: "#linear-gradient-269"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: 294.54,
    y1: 5.78,
    x2: 306.2,
    y2: 25.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "silver"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 294.52,
    y1: 5.83,
    x2: 306.13,
    y2: 25.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c1c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 294.51,
    y1: 5.88,
    x2: 306.06,
    y2: 25.41,
    xlinkHref: "#linear-gradient-272"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: 294.49,
    y1: 5.93,
    x2: 305.99,
    y2: 25.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c2c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: 294.47,
    y1: 5.98,
    x2: 305.92,
    y2: 25.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c3c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: 294.46,
    y1: 6.03,
    x2: 305.85,
    y2: 25.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: 294.44,
    y1: 6.07,
    x2: 305.78,
    y2: 25.24,
    xlinkHref: "#linear-gradient-276"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: 294.43,
    y1: 6.12,
    x2: 305.71,
    y2: 25.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5c5c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: 294.41,
    y1: 6.17,
    x2: 305.64,
    y2: 25.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: 294.39,
    y1: 6.22,
    x2: 305.57,
    y2: 25.12,
    xlinkHref: "#linear-gradient-279"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: 294.38,
    y1: 6.27,
    x2: 305.5,
    y2: 25.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7c7c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: 294.36,
    y1: 6.32,
    x2: 305.43,
    y2: 25.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: 294.35,
    y1: 6.37,
    x2: 305.36,
    y2: 24.99,
    xlinkHref: "#linear-gradient-282"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: 294.33,
    y1: 6.42,
    x2: 305.29,
    y2: 24.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9c9c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: 294.31,
    y1: 6.47,
    x2: 305.22,
    y2: 24.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacaca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: 294.3,
    y1: 6.52,
    x2: 305.15,
    y2: 24.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: 294.28,
    y1: 6.57,
    x2: 305.08,
    y2: 24.83,
    xlinkHref: "#linear-gradient-286"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    x1: 294.27,
    y1: 6.62,
    x2: 305.01,
    y2: 24.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    x1: 294.25,
    y1: 6.67,
    x2: 304.95,
    y2: 24.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    x1: 294.23,
    y1: 6.71,
    x2: 304.88,
    y2: 24.71,
    xlinkHref: "#linear-gradient-289"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    x1: 294.22,
    y1: 6.76,
    x2: 304.81,
    y2: 24.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cecece"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    x1: 294.2,
    y1: 6.81,
    x2: 304.74,
    y2: 24.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    x1: 294.19,
    y1: 6.86,
    x2: 304.67,
    y2: 24.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0d0d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    x1: 294.17,
    y1: 6.91,
    x2: 304.6,
    y2: 24.54,
    xlinkHref: "#linear-gradient-293"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    x1: 294.15,
    y1: 6.96,
    x2: 304.53,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    x1: 294.14,
    y1: 7.01,
    x2: 304.46,
    y2: 24.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d2d2d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    x1: 294.12,
    y1: 7.06,
    x2: 304.39,
    y2: 24.42,
    xlinkHref: "#linear-gradient-296"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    x1: 294.11,
    y1: 7.11,
    x2: 304.32,
    y2: 24.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    x1: 294.09,
    y1: 7.16,
    x2: 304.25,
    y2: 24.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d4d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: 294.07,
    y1: 7.2,
    x2: 304.18,
    y2: 24.29,
    xlinkHref: "#linear-gradient-299"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    x1: 294.06,
    y1: 7.25,
    x2: 304.11,
    y2: 24.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5d5d5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    x1: 294.04,
    y1: 7.3,
    x2: 304.04,
    y2: 24.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-303",
    x1: 294.02,
    y1: 7.35,
    x2: 303.97,
    y2: 24.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7d7d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-304",
    x1: 294.01,
    y1: 7.4,
    x2: 303.91,
    y2: 24.13,
    xlinkHref: "#linear-gradient-303"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-305",
    x1: 293.99,
    y1: 7.45,
    x2: 303.84,
    y2: 24.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-306",
    x1: 293.98,
    y1: 7.5,
    x2: 303.77,
    y2: 24.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-307",
    x1: 293.96,
    y1: 7.55,
    x2: 303.7,
    y2: 24.01,
    xlinkHref: "#linear-gradient-306"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-308",
    x1: 293.94,
    y1: 7.6,
    x2: 303.63,
    y2: 23.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dadada"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-309",
    x1: 293.93,
    y1: 7.65,
    x2: 303.56,
    y2: 23.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-310",
    x1: 293.91,
    y1: 7.69,
    x2: 303.49,
    y2: 23.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcdcdc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-311",
    x1: 293.9,
    y1: 7.74,
    x2: 303.42,
    y2: 23.84,
    xlinkHref: "#linear-gradient-310"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-312",
    x1: 293.88,
    y1: 7.79,
    x2: 303.35,
    y2: 23.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-313",
    x1: 293.86,
    y1: 7.84,
    x2: 303.28,
    y2: 23.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dedede"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-314",
    x1: 293.85,
    y1: 7.89,
    x2: 303.21,
    y2: 23.72,
    xlinkHref: "#linear-gradient-313"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-315",
    x1: 293.83,
    y1: 7.94,
    x2: 303.14,
    y2: 23.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfdfdf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-316",
    x1: 293.82,
    y1: 7.99,
    x2: 303.07,
    y2: 23.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-317",
    x1: 293.8,
    y1: 8.04,
    x2: 303,
    y2: 23.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e1e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-318",
    x1: 293.78,
    y1: 8.09,
    x2: 302.93,
    y2: 23.56,
    xlinkHref: "#linear-gradient-317"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-319",
    x1: 293.77,
    y1: 8.13,
    x2: 302.87,
    y2: 23.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-320",
    x1: 293.75,
    y1: 8.18,
    x2: 302.8,
    y2: 23.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-321",
    x1: 293.73,
    y1: 8.23,
    x2: 302.73,
    y2: 23.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-322",
    x1: 293.72,
    y1: 8.28,
    x2: 302.66,
    y2: 23.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-323",
    x1: 293.7,
    y1: 8.33,
    x2: 302.59,
    y2: 23.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-324",
    x1: 293.68,
    y1: 8.38,
    x2: 302.52,
    y2: 23.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-325",
    x1: 293.67,
    y1: 8.43,
    x2: 302.45,
    y2: 23.27,
    xlinkHref: "#linear-gradient-324"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-326",
    x1: 293.65,
    y1: 8.48,
    x2: 302.38,
    y2: 23.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e7e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-327",
    x1: 293.64,
    y1: 8.52,
    x2: 302.31,
    y2: 23.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-328",
    x1: 293.62,
    y1: 8.57,
    x2: 302.24,
    y2: 23.15,
    xlinkHref: "#linear-gradient-327"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-329",
    x1: 293.6,
    y1: 8.62,
    x2: 302.17,
    y2: 23.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-330",
    x1: 293.59,
    y1: 8.67,
    x2: 302.1,
    y2: 23.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaeaea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-331",
    x1: 293.57,
    y1: 8.72,
    x2: 302.03,
    y2: 23.03,
    xlinkHref: "#linear-gradient-330"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-332",
    x1: 293.55,
    y1: 8.77,
    x2: 301.97,
    y2: 22.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebebeb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-333",
    x1: 293.54,
    y1: 8.82,
    x2: 301.9,
    y2: 22.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ececec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-334",
    x1: 293.52,
    y1: 8.86,
    x2: 301.83,
    y2: 22.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ededed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-335",
    x1: 293.5,
    y1: 8.91,
    x2: 301.76,
    y2: 22.87,
    xlinkHref: "#linear-gradient-334"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-336",
    x1: 293.49,
    y1: 8.96,
    x2: 301.69,
    y2: 22.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-337",
    x1: 293.47,
    y1: 9.01,
    x2: 301.62,
    y2: 22.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-338",
    x1: 293.46,
    y1: 9.06,
    x2: 301.55,
    y2: 22.74,
    xlinkHref: "#linear-gradient-337"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-339",
    x1: 293.44,
    y1: 9.11,
    x2: 301.48,
    y2: 22.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-340",
    x1: 293.42,
    y1: 9.16,
    x2: 301.41,
    y2: 22.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-341",
    x1: 293.41,
    y1: 9.2,
    x2: 301.34,
    y2: 22.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f2f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.25,28.79,21.1,23.36H10.38l-2,5.43H1.07L12.69,1.1h6.49l11.5,27.69ZM15.82,8.49,12.3,18h7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.7,22.91a10,10,0,0,1-2.41,3.52,11.24,11.24,0,0,1-3.77,2.29,15.17,15.17,0,0,1-9.84,0A10.91,10.91,0,0,1,36,26.43a9.94,9.94,0,0,1-2.35-3.52,12.34,12.34,0,0,1-.82-4.56V1.1h6.65V17.8a7.55,7.55,0,0,0,.3,2.15,5.26,5.26,0,0,0,.9,1.82A4.13,4.13,0,0,0,42.24,23a6.39,6.39,0,0,0,4.81,0,4.2,4.2,0,0,0,1.62-1.27,4.93,4.93,0,0,0,.9-1.82,7.92,7.92,0,0,0,.28-2.15V1.1h6.69V18.35A12,12,0,0,1,55.7,22.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.57,6.81v22H67.88v-22H60.06V1.1H82.39V6.81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.92,14.83a15.35,15.35,0,0,1-1.13,6,13.71,13.71,0,0,1-3.15,4.66,13.93,13.93,0,0,1-4.79,3,16.91,16.91,0,0,1-6,1.06,16.74,16.74,0,0,1-6-1.06,13.94,13.94,0,0,1-4.77-3,13.43,13.43,0,0,1-3.15-4.66,15.35,15.35,0,0,1-1.14-6,15.22,15.22,0,0,1,1.14-6,13,13,0,0,1,3.15-4.55,13.89,13.89,0,0,1,4.77-2.9,18.25,18.25,0,0,1,12,0,13.88,13.88,0,0,1,4.79,2.9,13.26,13.26,0,0,1,3.15,4.55A15.22,15.22,0,0,1,113.92,14.83Zm-7.15,0a9.59,9.59,0,0,0-.59-3.37,8.11,8.11,0,0,0-1.62-2.68A7.63,7.63,0,0,0,102.05,7a7.93,7.93,0,0,0-3.23-.64,7.75,7.75,0,0,0-3.2.64,7.51,7.51,0,0,0-4.13,4.44,9.81,9.81,0,0,0-.57,3.37,9.93,9.93,0,0,0,.59,3.46A8.2,8.2,0,0,0,93.13,21a7.32,7.32,0,0,0,2.49,1.78,8.35,8.35,0,0,0,6.41,0A7.6,7.6,0,0,0,104.54,21a8.07,8.07,0,0,0,1.64-2.72A9.93,9.93,0,0,0,106.77,14.83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.24,28.79l.16-19.6h-.12l-7.2,19.6h-4.69l-7-19.6h-.12l.16,19.6h-6.3V1.1h9.51L135,18.86h.16l6-17.76h9.67V28.79Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176,28.79l-2.15-5.43H163.17l-2,5.43h-7.28L165.48,1.1H172l11.5,27.69Zm-7.43-20.3L165.09,18h7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.39,28.79l-6-11H193.1v11h-6.53V1.1h10.56a18,18,0,0,1,3.89.41,10.07,10.07,0,0,1,3.4,1.39,7.2,7.2,0,0,1,2.41,2.58,8.06,8.06,0,0,1,.9,4,7.34,7.34,0,0,1-1.53,4.73A8.28,8.28,0,0,1,202,16.94l7.24,11.85Zm-.27-19.2a2.65,2.65,0,0,0-1.48-2.53,4.65,4.65,0,0,0-1.45-.45,10.56,10.56,0,0,0-1.55-.11h-3.58V13h3.18a9.8,9.8,0,0,0,1.69-.14,5.31,5.31,0,0,0,1.58-.49,3,3,0,0,0,1.16-1A3,3,0,0,0,201.12,9.59Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.18,28.79,219.89,16h-.07V28.79h-6.54V1.1h6.54V12.36h.11l9.9-11.26h8.37L226.27,13.85l12.64,14.94Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.44,44.69a5.3,5.3,0,0,1,5.31-5.32,5.32,5.32,0,1,1,0,10.63,5.34,5.34,0,0,1-5.31-5.31ZM309.75,48a3.22,3.22,0,0,0,2.94-3.35,3.18,3.18,0,0,0-2.94-3.36,3.09,3.09,0,0,0-2.93,3.36A3.12,3.12,0,0,0,309.75,48"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "321.08 41.61 321.08 49.72 318.84 49.72 318.84 41.61 315.63 41.61 315.63 39.79 324.15 39.79 324.15 41.61 321.08 41.61"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.81,47.48h0L326,49.72h-2.66l4.2-9.93h2.79l4.06,9.93H331.7l-.84-2.24Zm2.1-1.68h1.39l-1.39-3.63-1.4,3.63h1.4"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "279.97 41.61 279.97 49.72 277.74 49.72 277.74 41.61 274.66 41.61 274.66 39.79 283.05 39.79 283.05 41.61 279.97 41.61"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.61,44.69a5.31,5.31,0,1,1,10.62,0,5.31,5.31,0,0,1-10.62,0ZM288.92,48a3.2,3.2,0,0,0,2.94-3.35,3.16,3.16,0,0,0-2.94-3.36A3.11,3.11,0,0,0,286,44.69,3.14,3.14,0,0,0,288.92,48"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "299.27 49.72 300.38 49.72 300.38 45.94 304.3 39.79 301.78 39.79 299.27 43.99 296.89 39.79 294.23 39.79 298.15 45.94 298.15 49.72 299.27 49.72"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M322.83,5.31C318.2,2.14,311.68.4,304.49.4s-13.72,1.74-18.34,4.91-7.21,7.66-7.21,12.62,2.67,9.38,7.52,12.63,11.13,4.91,18,4.91,13.29-1.75,18-4.91S330,22.83,330,17.93,327.47,8.49,322.83,5.31ZM319.56,9a2.12,2.12,0,0,1-1.09,1.64,18.53,18.53,0,0,1-7.13,2.07h0c-.16,0-.23,0-.25-.15a18.3,18.3,0,0,0-2.84-8.06v0l0,0,0,0c-.16-.21-.05-.31.17-.28C314.84,4.83,319.56,7.19,319.56,9Zm-15.07-.87c1,0,1.92,1.88,2.4,4.73,0,.11,0,.21-.17.22h0c-.73,0-1.48,0-2.23,0s-1.51,0-2.25,0c-.15,0-.18-.11-.16-.22C302.57,10,303.51,8.11,304.49,8.11Zm-3.81-4c.22,0,.33.08.16.29h0a18.31,18.31,0,0,0-2.93,8.08v0c0,.13-.1.19-.26.17a18.06,18.06,0,0,1-7.19-2.11,2.06,2.06,0,0,1-1-1.6C289.41,7.18,294.16,4.81,300.68,4.12ZM283.73,17.89A11.53,11.53,0,0,1,284.86,13c.09-.2.22-.13.3,0l0,0c1.83,2.49,6.26,4.42,12.13,5.25h0c.13,0,.22.06.22.24v0c.13,5.39,1.38,10.18,3.33,12.91h0c.1.15.07.28-.17.25a24.06,24.06,0,0,1-12-4.61C285.51,24.51,283.73,21.25,283.73,17.89Zm20.76,8.29c-1.25,0-2.43-3.26-2.69-7.34a.18.18,0,0,1,.2-.2h0c.82,0,1.65.06,2.49.06s1.66,0,2.48-.06h0c.13,0,.21.06.2.19C306.91,22.92,305.73,26.18,304.49,26.18Zm15.75.87a24.21,24.21,0,0,1-11.94,4.61h0c-.25,0-.28-.1-.17-.25h0c1.95-2.74,3.19-7.53,3.32-12.91v0c0-.18.1-.23.22-.24h0c5.88-.83,10.3-2.76,12.14-5.26v0c.09-.12.21-.19.3,0a11.61,11.61,0,0,1,1.13,5C325.24,21.25,323.46,24.51,320.24,27.05Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M304.49,32.12c-12.09,0-21-6.56-21-14.23A12.1,12.1,0,0,1,285,12.2h0a7.51,7.51,0,0,1,.25-2.53,13.38,13.38,0,0,0-3,8.25c0,8.51,9.45,15.11,22.28,15.11Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M304.49,33c12.82,0,22.28-6.6,22.28-15.11a13.44,13.44,0,0,0-3-8.25h0A7.82,7.82,0,0,1,324,12.2h0a12.11,12.11,0,0,1,1.47,5.69c0,7.67-8.91,14.23-21,14.23Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M304.49,2.67c-6.74,0-16.8,2.43-16.8,6.21,0,2.45,4.49,5.31,16.8,5.31s16.8-2.86,16.8-5.31C321.29,5.1,311.22,2.67,304.49,2.67Zm14.11,8.14c-2.17,1.42-7,2.52-14.11,2.52s-12-1.12-14.17-2.56A2.24,2.24,0,0,1,289.17,9c0-2.31,6.74-5.3,15.32-5.3s15.31,3,15.31,5.3A2.29,2.29,0,0,1,318.6,10.81Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M323.77,9.67h0a5.46,5.46,0,0,1,0,.56c0,3.08-6.08,7.27-19.32,7.27s-19.33-4.19-19.33-7.27a3.64,3.64,0,0,1,0-.56h0A7.51,7.51,0,0,0,285,12.2c1.6,3,7.87,6.26,19.53,6.26S322.42,15.2,324,12.2A7.82,7.82,0,0,0,323.77,9.67Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M301.77,13.28c.46-3.23,1.5-5.4,2.72-5.4s2.25,2.17,2.72,5.4l.83.83c-.45-4.35-1.87-7.52-3.55-7.52s-3.11,3.17-3.56,7.52Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M307.36,3.79a5.91,5.91,0,0,0-2.83-.69h.19c1.41.09,2.48,1.2,3.42,3.08A23.45,23.45,0,0,1,310.2,14l.71-1C310.37,8.75,309.07,5.52,307.36,3.79ZM298.07,13l.71,1h0a23.38,23.38,0,0,1,2.1-7.75c1-2,2.14-3.1,3.65-3.1a5.51,5.51,0,0,0-2.84.69C300,5.51,298.63,8.74,298.07,13Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M311.19,18.05l-.81-.86v.3c0,8.38-2.63,15.17-5.88,15.17a7.09,7.09,0,0,0,2.82-.66C309.55,29.53,311.12,24.23,311.19,18.05Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M307.44,18.38c-.21,4.47-1.45,8-2.95,8s-2.75-3.56-3-8l-.74-1c.07,5.62,1.82,10.32,3.7,10.32h0c1.76-.05,3.42-4.25,3.64-9.44,0-.29,0-.58,0-.88Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M304.36,32.66l-.17,0c-3.13-.4-5.6-7-5.6-15.15,0-.1,0-.2,0-.3l-.82.86c.08,6.18,1.64,11.48,3.87,14a7.17,7.17,0,0,0,2.83.66Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M329.88,17.93c0,10.12-11.37,17.36-25.39,17.36s-25.4-7.24-25.4-17.36S289.63.57,304.49.57,329.88,7.82,329.88,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M329.87,17.93c0,10.11-11.36,17.35-25.38,17.35S279.1,28,279.1,17.93,289.64.58,304.49.58,329.87,7.83,329.87,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M329.86,17.93c0,10.1-11.36,17.34-25.37,17.34S279.11,28,279.11,17.93,289.65.59,304.49.59,329.86,7.83,329.86,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M329.85,17.93c0,10.1-11.35,17.33-25.36,17.33S279.12,28,279.12,17.93,289.65.6,304.49.6,329.85,7.84,329.85,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M329.84,17.93c0,10.09-11.35,17.32-25.35,17.32S279.13,28,279.13,17.93,289.66.61,304.49.61,329.84,7.84,329.84,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M329.83,17.93c0,10.08-11.35,17.3-25.34,17.3S279.14,28,279.14,17.93,289.66.62,304.49.62,329.83,7.85,329.83,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M329.82,17.93c0,10.07-11.34,17.29-25.33,17.29S279.15,28,279.15,17.93,289.67.63,304.49.63,329.82,7.85,329.82,17.93Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 304.49,
    cy: 17.93,
    rx: 25.33,
    ry: 17.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M329.8,17.93c0,10.06-11.33,17.27-25.31,17.27S279.17,28,279.17,17.93,289.68.65,304.49.65,329.8,7.86,329.8,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M329.79,17.93c0,10.05-11.33,17.26-25.3,17.26S279.18,28,279.18,17.93,289.69.66,304.49.66,329.79,7.87,329.79,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M329.78,17.93c0,10.05-11.32,17.25-25.29,17.25s-25.3-7.2-25.3-17.25S289.69.67,304.49.67,329.78,7.88,329.78,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M329.77,17.93c0,10-11.32,17.24-25.28,17.24S279.2,28,279.2,17.93,289.7.68,304.49.68,329.77,7.88,329.77,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M329.76,17.93c0,10-11.31,17.23-25.27,17.23S279.21,28,279.21,17.93,289.71.69,304.49.69,329.76,7.89,329.76,17.93Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 304.49,
    cy: 17.92,
    rx: 25.26,
    ry: 17.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M329.74,17.92c0,10-11.31,17.22-25.25,17.22S279.23,28,279.23,17.92,289.72.71,304.49.71,329.74,7.9,329.74,17.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 304.49,
    cy: 17.92,
    rx: 25.24,
    ry: 17.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M329.72,17.92c0,10-11.3,17.19-25.23,17.19s-25.24-7.17-25.24-17.19S289.73.73,304.49.73,329.72,7.91,329.72,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329.71,17.92c0,10-11.29,17.18-25.22,17.18s-25.23-7.17-25.23-17.18S289.74.74,304.49.74,329.71,7.91,329.71,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M329.7,17.92c0,10-11.29,17.17-25.21,17.17s-25.22-7.17-25.22-17.17S289.74.75,304.49.75,329.7,7.92,329.7,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M329.69,17.92c0,10-11.29,17.16-25.2,17.16s-25.21-7.16-25.21-17.16S289.75.76,304.49.76,329.69,7.93,329.69,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M329.68,17.92c0,10-11.28,17.15-25.19,17.15s-25.2-7.16-25.2-17.15S289.75.77,304.49.77,329.68,7.93,329.68,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M329.67,17.92c0,10-11.28,17.14-25.18,17.14S279.3,27.9,279.3,17.92,289.76.78,304.49.78,329.67,7.94,329.67,17.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-36",
    cx: 304.49,
    cy: 17.92,
    rx: 25.17,
    ry: 17.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M329.64,17.92c0,10-11.26,17.12-25.15,17.12s-25.16-7.15-25.16-17.12S289.78.8,304.49.8,329.64,7.94,329.64,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M329.63,17.92c0,10-11.26,17.11-25.14,17.11s-25.15-7.14-25.15-17.11S289.78.8,304.49.8,329.63,8,329.63,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M329.62,17.92c0,10-11.26,17.1-25.13,17.1s-25.13-7.14-25.13-17.1S289.79.81,304.49.81,329.62,8,329.62,17.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 304.49,
    cy: 17.92,
    rx: 25.12,
    ry: 17.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M329.59,17.92c0,10-11.24,17.09-25.1,17.09s-25.11-7.14-25.11-17.09S289.81.83,304.49.83,329.59,8,329.59,17.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 304.49,
    cy: 17.92,
    rx: 25.09,
    ry: 17.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M329.56,17.92c0,9.94-11.22,17.07-25.07,17.07s-25.08-7.13-25.08-17.07S289.82.85,304.49.85,329.56,8,329.56,17.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-44",
    cx: 304.49,
    cy: 17.92,
    rx: 25.06,
    ry: 17.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M329.54,17.92c0,9.94-11.22,17.06-25.05,17.06s-25.05-7.12-25.05-17.06S289.84.86,304.49.86,329.54,8,329.54,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M329.52,17.92c0,9.93-11.21,17-25,17s-25-7.12-25-17,10.4-17,25-17S329.52,8,329.52,17.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-47",
    cx: 304.49,
    cy: 17.92,
    rx: 25.02,
    ry: 17.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M329.5,17.92c0,9.92-11.2,17-25,17s-25-7.11-25-17,10.39-17,25-17S329.5,8,329.5,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M329.48,17.92c0,9.92-11.19,17-25,17s-25-7.1-25-17,10.38-17,25-17S329.48,8,329.48,17.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M329.47,17.92c0,9.91-11.19,17-25,17s-25-7.11-25-17,10.38-17,25-17S329.47,8,329.47,17.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-51",
    cx: 304.49,
    cy: 17.92,
    rx: 24.97,
    ry: 17.01
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-52",
    cx: 304.49,
    cy: 17.92,
    rx: 24.96,
    ry: 17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 304.49,
    cy: 17.92,
    rx: 24.95,
    ry: 16.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M329.42,17.92c0,9.89-11.16,17-24.93,17s-24.94-7.09-24.94-17,10.36-17,24.94-17S329.42,8,329.42,17.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-55",
    cx: 304.49,
    cy: 17.92,
    rx: 24.92,
    ry: 16.98
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 304.49,
    cy: 17.92,
    rx: 24.91,
    ry: 16.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 304.49,
    cy: 17.92,
    rx: 24.91,
    ry: 16.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M329.36,17.9c0,9.87-11.14,16.94-24.89,16.94s-24.88-7.05-24.88-16.93S289.93,1,304.47,1,329.36,8,329.36,17.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M329.32,17.89c0,9.85-11.13,16.9-24.86,16.9s-24.86-7-24.87-16.89S289.93,1,304.46,1,329.32,8,329.32,17.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M329.28,17.87c0,9.84-11.11,16.88-24.83,16.88s-24.84-7-24.85-16.86S289.93,1,304.45,1,329.28,8,329.28,17.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M329.25,17.86c0,9.83-11.11,16.84-24.81,16.84s-24.82-6.94-24.84-16.82S289.93,1,304.44,1,329.25,8,329.25,17.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M329.21,17.84c0,9.82-11.1,16.81-24.78,16.81s-24.8-6.9-24.82-16.78S289.93,1,304.43,1,329.21,8,329.21,17.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M329.17,17.83c0,9.8-11.08,16.78-24.76,16.78s-24.77-6.88-24.8-16.74S289.94,1,304.41,1,329.17,8,329.17,17.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M329.14,17.81c0,9.79-11.08,16.75-24.74,16.75s-24.75-6.84-24.78-16.7S289.94,1,304.4,1,329.14,8,329.14,17.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M329.1,17.79c0,9.78-11.06,16.72-24.71,16.72s-24.73-6.8-24.77-16.66S289.94,1,304.39,1,329.1,8,329.1,17.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M329.06,17.78c0,9.76-11.05,16.68-24.68,16.68s-24.71-6.76-24.75-16.62S289.94,1,304.38,1,329.06,8,329.06,17.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M329,17.76c0,9.75-11,16.66-24.65,16.66s-24.69-6.73-24.73-16.59S289.94,1,304.37,1,329,8,329,17.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M329,17.75c0,9.73-11,16.62-24.64,16.62s-24.67-6.69-24.71-16.55S290,1.05,304.35,1.05,329,8,329,17.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M329,17.73c0,9.72-11,16.59-24.61,16.59s-24.65-6.65-24.69-16.51c0-9.71,10.3-16.76,24.69-16.76S329,8,329,17.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M328.91,17.72c0,9.7-11,16.56-24.58,16.56s-24.63-6.63-24.67-16.47S290,1.06,304.33,1.06,328.91,8,328.91,17.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M328.88,17.7c0,9.69-11,16.53-24.56,16.53s-24.61-6.59-24.66-16.43S290,1.07,304.32,1.07,328.88,8,328.88,17.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M328.84,17.69c0,9.67-11,16.49-24.54,16.49s-24.58-6.55-24.63-16.39C279.61,8.11,290,1.08,304.3,1.08S328.84,8,328.84,17.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M328.8,17.67c0,9.66-11,16.46-24.51,16.46s-24.56-6.51-24.62-16.35C279.61,8.12,290,1.09,304.29,1.09S328.8,8,328.8,17.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M328.77,17.66c0,9.64-11,16.43-24.49,16.43s-24.54-6.48-24.6-16.32C279.62,8.13,290,1.1,304.28,1.1S328.77,8,328.77,17.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M328.73,17.64c0,9.63-11,16.4-24.46,16.4s-24.52-6.44-24.59-16.28C279.62,8.13,290,1.11,304.27,1.11S328.73,8,328.73,17.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M328.69,17.63c0,9.61-10.94,16.36-24.44,16.36s-24.49-6.4-24.56-16.24C279.62,8.14,290,1.11,304.25,1.11S328.69,8,328.69,17.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M328.65,17.61c0,9.6-10.92,16.34-24.41,16.34s-24.47-6.38-24.55-16.21C279.62,8.14,290,1.12,304.24,1.12S328.65,8,328.65,17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M328.62,17.6c0,9.59-10.92,16.3-24.39,16.3s-24.45-6.34-24.53-16.16C279.62,8.15,290,1.13,304.23,1.13S328.62,8,328.62,17.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M328.58,17.58c0,9.58-10.91,16.27-24.36,16.27s-24.43-6.3-24.51-16.12C279.62,8.15,290,1.14,304.22,1.14S328.58,8,328.58,17.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M328.54,17.56c0,9.57-10.89,16.25-24.33,16.25s-24.41-6.27-24.5-16.09C279.63,8.16,290,1.15,304.21,1.15S328.54,8,328.54,17.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M328.51,17.55c0,9.55-10.89,16.21-24.32,16.21s-24.38-6.23-24.47-16C279.63,8.16,290,1.16,304.19,1.16S328.51,8,328.51,17.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M328.47,17.53c0,9.54-10.87,16.18-24.29,16.18s-24.36-6.19-24.46-16C279.63,8.17,290,1.17,304.18,1.17S328.47,8,328.47,17.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M328.43,17.52c0,9.52-10.86,16.14-24.26,16.14s-24.34-6.15-24.44-16C279.63,8.17,290,1.18,304.17,1.18S328.43,8,328.43,17.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M328.4,17.5c0,9.51-10.86,16.12-24.24,16.12s-24.32-6.13-24.43-15.94c-.09-9.5,10.25-16.5,24.43-16.5S328.4,8,328.4,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M328.36,17.49c0,9.49-10.84,16.08-24.21,16.08s-24.3-6.09-24.41-15.89C279.64,8.19,290,1.19,304.15,1.19S328.36,8,328.36,17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M328.32,17.47c0,9.48-10.83,16.05-24.19,16.05s-24.27-6.05-24.38-15.85C279.64,8.19,290,1.2,304.13,1.2S328.32,8,328.32,17.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M328.28,17.46c0,9.46-10.81,16-24.16,16s-24.25-6-24.37-15.82C279.64,8.2,290,1.21,304.12,1.21S328.28,8,328.28,17.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M328.25,17.44c0,9.45-10.81,16-24.14,16s-24.23-6-24.35-15.78C279.65,8.2,290,1.22,304.11,1.22S328.25,8,328.25,17.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M328.21,17.43c0,9.43-10.79,16-24.11,16s-24.21-5.94-24.34-15.74C279.65,8.21,290,1.23,304.1,1.23S328.21,8,328.21,17.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M328.17,17.41c0,9.42-10.78,15.92-24.09,15.92s-24.18-5.91-24.31-15.7C279.65,8.21,290,1.24,304.08,1.24S328.17,8,328.17,17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M328.14,17.4c0,9.4-10.78,15.89-24.07,15.89s-24.16-5.88-24.29-15.67C279.65,8.22,290,1.25,304.07,1.25S328.14,8,328.14,17.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M328.1,17.38c0,9.39-10.76,15.86-24,15.86s-24.14-5.84-24.28-15.63C279.65,8.22,290,1.26,304.06,1.26S328.1,8,328.1,17.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M328.06,17.36c0,9.38-10.75,15.83-24,15.83s-24.12-5.8-24.26-15.58C279.66,8.23,290,1.26,304.05,1.26S328.06,8,328.06,17.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M328,17.35c0,9.36-10.74,15.8-24,15.8s-24.1-5.77-24.25-15.55C279.66,8.23,290,1.27,304,1.27S328,8,328,17.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M328,17.33c0,9.35-10.73,15.77-24,15.77S280,27.37,279.8,17.59C279.66,8.24,290,1.28,304,1.28S328,8,328,17.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M328,17.32c0,9.33-10.72,15.73-23.94,15.73S280,27.36,279.81,17.58C279.66,8.24,290,1.29,304,1.29S328,8,328,17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M327.92,17.3C327.92,26.63,317.21,33,304,33s-24-5.66-24.19-15.44C279.66,8.25,290,1.3,304,1.3S327.92,8,327.92,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M327.88,17.29C327.88,26.6,317.18,33,304,33s-24-5.63-24.17-15.4C279.67,8.25,290,1.31,304,1.31S327.88,8,327.88,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M327.86,17.29C327.86,26.59,317.18,33,304,33s-24-5.64-24.15-15.39C279.69,8.25,290,1.32,304,1.32S327.86,8,327.86,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M327.85,17.29c0,9.3-10.68,15.65-23.86,15.65s-24-5.65-24.12-15.39C279.72,8.25,290,1.33,304,1.33S327.85,8,327.85,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M327.83,17.29c0,9.29-10.66,15.64-23.83,15.64s-24-5.66-24.11-15.39C279.75,8.25,290,1.35,304,1.35S327.83,8,327.83,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M327.81,17.29c0,9.29-10.65,15.64-23.81,15.64s-23.94-5.69-24.08-15.39C279.78,8.25,290,1.36,304,1.36S327.81,8,327.81,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M327.79,17.29c0,9.28-10.63,15.63-23.79,15.63s-23.92-5.7-24.06-15.39c-.13-9.28,10.11-16.15,24-16.15S327.79,8,327.79,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M327.78,17.29c0,9.28-10.62,15.62-23.77,15.62S280.1,27.2,280,17.53c-.13-9.28,10.09-16.14,24-16.14S327.78,8,327.78,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M327.76,17.29c0,9.27-10.61,15.61-23.75,15.61s-23.89-5.72-24-15.38C279.86,8.25,290.06,1.4,304,1.4S327.76,8,327.76,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M327.74,17.29c0,9.27-10.59,15.6-23.72,15.6s-23.88-5.74-24-15.38c-.12-9.26,10.06-16.09,24-16.09S327.74,8,327.74,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M327.72,17.29c0,9.26-10.58,15.59-23.7,15.59s-23.86-5.75-24-15.37c-.12-9.26,10-16.08,23.93-16.08S327.72,8,327.72,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M327.7,17.29c0,9.26-10.56,15.59-23.68,15.59s-23.84-5.77-24-15.38c-.11-9.25,10-16,23.91-16S327.7,8,327.7,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M327.69,17.3c0,9.25-10.56,15.57-23.66,15.57S280.2,27.09,280.09,17.5c-.11-9.25,10-16,23.88-16S327.69,8.05,327.69,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M327.67,17.3c0,9.24-10.54,15.56-23.64,15.56s-23.81-5.8-23.92-15.37c-.1-9.24,10-16,23.86-16S327.67,8.05,327.67,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M327.65,17.3c0,9.24-10.53,15.55-23.62,15.55S280.25,27,280.14,17.48c-.11-9.23,10-16,23.83-16S327.65,8.06,327.65,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M327.64,17.3c0,9.23-10.52,15.54-23.6,15.54S280.26,27,280.16,17.48c-.1-9.23,9.95-16,23.81-16S327.64,8.07,327.64,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M327.62,17.3c0,9.23-10.5,15.53-23.58,15.53S280.29,27,280.19,17.47c-.1-9.22,9.93-15.95,23.77-15.95S327.62,8.07,327.62,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M327.6,17.3c0,9.22-10.49,15.53-23.56,15.53S280.31,27,280.21,17.47C280.12,8.25,290.12,1.53,304,1.53S327.6,8.08,327.6,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M327.58,17.3c0,9.22-10.47,15.52-23.53,15.52S280.33,27,280.24,17.46C280.15,8.24,290.13,1.54,304,1.54S327.58,8.08,327.58,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M327.57,17.3c0,9.21-10.47,15.51-23.52,15.51s-23.7-5.88-23.79-15.35c-.08-9.22,9.88-15.9,23.7-15.9S327.57,8.09,327.57,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M327.55,17.3c0,9.21-10.45,15.5-23.5,15.5s-23.68-5.89-23.77-15.35C280.2,8.24,290.14,1.57,304,1.57S327.55,8.1,327.55,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M327.53,17.3c0,9.2-10.43,15.49-23.47,15.49s-23.67-5.91-23.75-15.35c-.08-9.2,9.84-15.86,23.64-15.86S327.53,8.1,327.53,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M327.52,17.3c0,9.2-10.43,15.49-23.46,15.49s-23.65-5.93-23.73-15.35C280.26,8.24,290.16,1.6,304,1.6S327.52,8.11,327.52,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M327.5,17.3c0,9.19-10.41,15.48-23.44,15.48s-23.63-5.94-23.7-15.35c-.07-9.19,9.8-15.82,23.59-15.82S327.5,8.11,327.5,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M327.48,17.31c0,9.18-10.4,15.46-23.41,15.46s-23.62-6-23.69-15.34c-.06-9.19,9.79-15.8,23.57-15.8S327.48,8.12,327.48,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M327.46,17.31c0,9.18-10.38,15.45-23.39,15.45s-23.6-6-23.66-15.34C280.35,8.24,290.18,1.64,304,1.64S327.46,8.13,327.46,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M327.45,17.31c0,9.17-10.38,15.44-23.37,15.44s-23.59-6-23.65-15.34C280.37,8.24,290.19,1.66,304,1.66S327.45,8.13,327.45,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M327.43,17.31c0,9.17-10.36,15.43-23.35,15.43s-23.56-6-23.62-15.33C280.4,8.24,290.19,1.67,304,1.67S327.43,8.14,327.43,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M327.41,17.31c0,9.16-10.35,15.43-23.33,15.43s-23.54-6-23.6-15.34c-.05-9.16,9.72-15.72,23.46-15.72S327.41,8.14,327.41,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M327.39,17.31c0,9.16-10.33,15.42-23.3,15.42s-23.53-6-23.58-15.33,9.7-15.7,23.43-15.7S327.39,8.15,327.39,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M327.38,17.31c0,9.15-10.32,15.41-23.29,15.41s-23.51-6-23.56-15.33,9.68-15.68,23.41-15.68S327.38,8.16,327.38,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M327.36,17.31c0,9.15-10.31,15.4-23.27,15.4s-23.49-6.05-23.53-15.32,9.66-15.67,23.38-15.67S327.36,8.16,327.36,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M327.34,17.31c0,9.14-10.29,15.39-23.24,15.39s-23.48-6.07-23.52-15.32,9.64-15.64,23.36-15.64S327.34,8.17,327.34,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M327.33,17.31c0,9.14-10.29,15.38-23.23,15.38s-23.46-6.08-23.49-15.32,9.62-15.62,23.33-15.62S327.33,8.18,327.33,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M327.31,17.31c0,9.13-10.27,15.38-23.2,15.38s-23.45-6.1-23.48-15.32,9.61-15.6,23.3-15.6S327.31,8.18,327.31,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M327.29,17.31c0,9.13-10.26,15.37-23.18,15.37s-23.43-6.11-23.46-15.32,9.6-15.58,23.28-15.58S327.29,8.19,327.29,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M327.27,17.31c0,9.13-10.24,15.36-23.16,15.36s-23.41-6.13-23.43-15.32,9.57-15.56,23.25-15.56S327.27,8.19,327.27,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M327.26,17.31c0,9.12-10.23,15.35-23.14,15.35s-23.4-6.14-23.42-15.31,9.56-15.54,23.23-15.54S327.26,8.2,327.26,17.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M327.24,17.32c0,9.11-10.22,15.33-23.12,15.33s-23.38-6.15-23.39-15.31,9.54-15.52,23.2-15.52S327.24,8.21,327.24,17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M327.22,17.32c0,9.1-10.2,15.32-23.1,15.32s-23.35-6.16-23.37-15.3,9.52-15.5,23.18-15.5S327.22,8.21,327.22,17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M327.2,17.32c0,9.1-10.19,15.32-23.07,15.32s-23.34-6.19-23.35-15.31,9.5-15.48,23.14-15.48S327.2,8.22,327.2,17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M327.19,17.32c0,9.09-10.18,15.31-23.06,15.31s-23.32-6.2-23.33-15.3,9.49-15.47,23.12-15.47S327.19,8.22,327.19,17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M327.17,17.32c0,9.09-10.17,15.3-23,15.3s-23.3-6.21-23.3-15.3,9.46-15.44,23.09-15.44S327.17,8.23,327.17,17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M327.12,17.3c0,9.07-10.15,15.28-23,15.28s-23.27-6.21-23.27-15.28,9.46-15.41,23.07-15.41S327.12,8.23,327.12,17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M327.07,17.29c0,9-10.14,15.24-23,15.24s-23.23-6.2-23.23-15.24,9.45-15.38,23-15.38S327.07,8.24,327.07,17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M327,17.27c0,9-10.13,15.22-22.94,15.22s-23.19-6.19-23.19-15.22,9.45-15.35,23-15.35S327,8.24,327,17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M327,17.25c0,9-10.12,15.19-22.91,15.19s-23.15-6.18-23.15-15.19,9.45-15.31,23-15.31S327,8.24,327,17.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M326.93,17.23c0,9-10.12,15.17-22.89,15.17s-23.12-6.18-23.12-15.17S290.37,2,303.89,2,326.93,8.25,326.93,17.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M326.88,17.22c0,9-10.1,15.13-22.85,15.13s-23.09-6.17-23.09-15.13S290.39,2,303.88,2,326.88,8.25,326.88,17.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M326.83,17.2c0,9-10.09,15.11-22.82,15.11S281,26.15,281,17.2,290.4,2,303.88,2,326.83,8.25,326.83,17.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M326.78,17.18c0,8.93-10.08,15.08-22.79,15.08s-23-6.15-23-15.08S290.42,2,303.87,2,326.78,8.26,326.78,17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M326.73,17.17c0,8.9-10.07,15-22.76,15s-23-6.15-23-15S290.43,2,303.87,2,326.73,8.26,326.73,17.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M326.69,17.15c0,8.88-10.07,15-22.74,15S281,26,281,17.15,290.45,2,303.86,2,326.69,8.26,326.69,17.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M326.64,17.13c0,8.86-10.06,15-22.7,15S281,26,281,17.13s9.43-15.08,22.82-15.08S326.64,8.27,326.64,17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M326.59,17.11c0,8.85-10,15-22.67,15s-22.86-6.12-22.86-15,9.42-15,22.79-15S326.59,8.27,326.59,17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M326.54,17.1c0,8.82-10,14.94-22.64,14.94s-22.82-6.12-22.82-14.94,9.42-15,22.76-15S326.54,8.27,326.54,17.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M326.49,17.08c0,8.8-10,14.91-22.61,14.91S281.1,25.88,281.1,17.08s9.41-15,22.74-15S326.49,8.28,326.49,17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M326.44,17.06c0,8.79-10,14.89-22.57,14.89s-22.75-6.1-22.75-14.89,9.41-14.95,22.71-14.95S326.44,8.28,326.44,17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M326.4,17c0,8.77-10,14.86-22.55,14.86S281.14,25.81,281.14,17s9.4-14.91,22.68-14.91S326.4,8.28,326.4,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M326.35,17c0,8.74-10,14.83-22.52,14.83S281.16,25.77,281.16,17s9.4-14.89,22.66-14.89S326.35,8.29,326.35,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M326.3,17c0,8.72-10,14.8-22.49,14.8S281.18,25.73,281.18,17s9.39-14.85,22.63-14.85S326.3,8.29,326.3,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M326.25,17c0,8.7-10,14.78-22.46,14.78S281.2,25.69,281.2,17s9.39-14.81,22.61-14.81S326.25,8.29,326.25,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M326.2,17c0,8.68-10,14.74-22.42,14.74S281.21,25.66,281.21,17s9.4-14.79,22.59-14.79S326.2,8.3,326.2,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M326.15,17c0,8.66-9.95,14.72-22.39,14.72S281.23,25.62,281.23,17s9.39-14.75,22.56-14.75S326.15,8.3,326.15,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M326.11,16.94c0,8.64-9.95,14.69-22.37,14.69s-22.49-6.05-22.49-14.69,9.39-14.72,22.54-14.72S326.11,8.3,326.11,16.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M326.06,16.93c0,8.62-9.94,14.66-22.34,14.66s-22.45-6-22.45-14.66,9.38-14.69,22.51-14.69S326.06,8.31,326.06,16.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M326,16.91c0,8.6-9.92,14.63-22.3,14.63s-22.42-6-22.42-14.63,9.38-14.66,22.48-14.66S326,8.31,326,16.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M326,16.89c0,8.58-9.91,14.61-22.27,14.61s-22.38-6-22.38-14.61,9.37-14.62,22.46-14.62S326,8.31,326,16.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M325.91,16.87c0,8.56-9.9,14.59-22.24,14.59s-22.34-6-22.34-14.59S290.7,2.28,303.76,2.28,325.91,8.32,325.91,16.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M325.87,16.86c0,8.54-9.9,14.55-22.22,14.55s-22.3-6-22.3-14.55S290.71,2.3,303.76,2.3,325.87,8.32,325.87,16.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M325.82,16.84c0,8.52-9.89,14.53-22.18,14.53s-22.27-6-22.27-14.53,9.36-14.52,22.38-14.52S325.82,8.32,325.82,16.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M325.77,16.82c0,8.5-9.88,14.5-22.15,14.5s-22.23-6-22.23-14.5,9.36-14.49,22.35-14.49S325.77,8.33,325.77,16.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M325.72,16.81c0,8.47-9.86,14.46-22.12,14.46s-22.19-6-22.19-14.46,9.35-14.46,22.33-14.46S325.72,8.33,325.72,16.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M325.67,16.79c0,8.45-9.85,14.44-22.09,14.44s-22.15-6-22.15-14.44,9.35-14.43,22.3-14.43S325.67,8.33,325.67,16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M325.62,16.77c0,8.44-9.84,14.42-22.06,14.42s-22.11-6-22.11-14.42,9.34-14.39,22.28-14.39S325.62,8.34,325.62,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M325.57,16.76c0,8.41-9.83,14.38-22,14.38s-22.09-6-22.09-14.38,9.35-14.37,22.26-14.37S325.57,8.34,325.57,16.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M325.53,16.74c0,8.39-9.83,14.36-22,14.36s-22-6-22-14.36,9.34-14.33,22.23-14.33S325.53,8.35,325.53,16.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M325.48,16.72c0,8.37-9.81,14.33-22,14.33s-22-6-22-14.33,9.34-14.3,22.21-14.3S325.48,8.35,325.48,16.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M325.43,16.7c0,8.36-9.8,14.31-21.94,14.31s-22-6-22-14.31S290.85,2.44,303.7,2.44,325.43,8.35,325.43,16.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M325.38,16.69c0,8.33-9.79,14.27-21.9,14.27S281.54,25,281.54,16.69,290.87,2.46,303.7,2.46,325.38,8.35,325.38,16.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M325.33,16.67c0,8.31-9.78,14.25-21.87,14.25s-21.9-5.94-21.9-14.25,9.33-14.2,22.13-14.2S325.33,8.36,325.33,16.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M325.29,16.65c0,8.3-9.78,14.22-21.85,14.22S281.58,25,281.58,16.65s9.32-14.16,22.1-14.16S325.29,8.36,325.29,16.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M325.24,16.64c0,8.27-9.77,14.19-21.82,14.19S281.6,24.91,281.6,16.64,290.92,2.5,303.68,2.5,325.24,8.36,325.24,16.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M325.19,16.62c0,8.25-9.75,14.16-21.78,14.16s-21.79-5.91-21.79-14.16,9.31-14.1,22.05-14.1S325.19,8.37,325.19,16.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M325.17,16.62c0,8.24-9.75,14.15-21.77,14.15s-21.76-5.91-21.76-14.15,9.3-14.09,22-14.09S325.17,8.38,325.17,16.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M325.15,16.62c0,8.23-9.74,14.13-21.75,14.13s-21.74-5.9-21.74-14.13,9.28-14.08,22-14.08S325.15,8.38,325.15,16.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M325.12,16.61c0,8.23-9.72,14.13-21.72,14.13s-21.72-5.9-21.72-14.13,9.26-14.06,22-14.06S325.12,8.39,325.12,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M325.1,16.61c0,8.22-9.71,14.11-21.7,14.11s-21.7-5.89-21.7-14.11,9.25-14,21.94-14S325.1,8.4,325.1,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M325.08,16.61c0,8.21-9.71,14.1-21.68,14.1s-21.69-5.89-21.69-14.1,9.24-14,21.92-14S325.08,8.4,325.08,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M325.06,16.61c0,8.2-9.7,14.08-21.66,14.08s-21.67-5.88-21.67-14.08,9.23-14,21.89-14S325.06,8.41,325.06,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M325,16.61c0,8.19-9.69,14.07-21.64,14.07s-21.65-5.88-21.65-14.07,9.21-14,21.87-14S325,8.42,325,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M325,16.61c0,8.18-9.68,14.05-21.62,14.05s-21.63-5.87-21.63-14,9.2-14,21.84-14S325,8.42,325,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M325,16.61c0,8.18-9.68,14-21.61,14s-21.6-5.85-21.6-14,9.18-14,21.81-14S325,8.43,325,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M325,16.61c0,8.16-9.67,14-21.59,14s-21.58-5.86-21.58-14,9.16-14,21.78-14S325,8.44,325,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M325,16.61c0,8.16-9.65,14-21.56,14s-21.56-5.84-21.56-14,9.15-14,21.76-14S325,8.45,325,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M324.93,16.61c0,8.15-9.64,14-21.54,14s-21.54-5.84-21.54-14S291,2.66,303.58,2.66,324.93,8.45,324.93,16.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M324.91,16.6c0,8.15-9.64,14-21.52,14s-21.52-5.83-21.52-14S291,2.67,303.57,2.67,324.91,8.46,324.91,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M324.89,16.6c0,8.14-9.63,14-21.5,14s-21.5-5.83-21.5-14S291,2.68,303.56,2.68,324.89,8.47,324.89,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M324.87,16.6c0,8.13-9.62,14-21.48,14S281.9,24.73,281.9,16.6,291,2.69,303.56,2.69,324.87,8.47,324.87,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M324.85,16.6c0,8.12-9.61,13.94-21.46,13.94s-21.47-5.82-21.47-13.94S291,2.7,303.55,2.7,324.85,8.48,324.85,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M324.82,16.6c0,8.11-9.59,13.92-21.44,13.92s-21.44-5.81-21.44-13.92S291,2.71,303.54,2.71,324.82,8.49,324.82,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M324.8,16.6c0,8.1-9.59,13.91-21.42,13.91S282,24.7,282,16.6,291,2.72,303.53,2.72,324.8,8.5,324.8,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M324.78,16.6c0,8.09-9.58,13.89-21.4,13.89S282,24.69,282,16.6s9-13.86,21.55-13.86S324.78,8.5,324.78,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M324.76,16.59c0,8.09-9.57,13.89-21.38,13.89S282,24.68,282,16.59s9-13.84,21.52-13.84S324.76,8.51,324.76,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M324.74,16.59c0,8.08-9.56,13.87-21.36,13.87S282,24.67,282,16.59s9-13.83,21.49-13.83S324.74,8.52,324.74,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M324.72,16.59c0,8.07-9.56,13.86-21.34,13.86S282,24.66,282,16.59,291,2.77,303.5,2.77,324.72,8.52,324.72,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M324.7,16.59c0,8.06-9.55,13.84-21.32,13.84s-21.32-5.78-21.32-13.84,9-13.81,21.43-13.81S324.7,8.53,324.7,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M324.68,16.59c0,8.05-9.54,13.82-21.3,13.82s-21.3-5.77-21.3-13.82S291,2.79,303.49,2.79,324.68,8.54,324.68,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M324.65,16.59c0,8-9.52,13.81-21.27,13.81S282.1,24.63,282.1,16.59,291,2.8,303.48,2.8,324.65,8.55,324.65,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M324.63,16.59c0,8-9.52,13.79-21.25,13.79s-21.26-5.76-21.26-13.79S291,2.82,303.47,2.82,324.63,8.55,324.63,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M324.61,16.59c0,8-9.51,13.78-21.24,13.78s-21.24-5.76-21.24-13.78S291,2.83,303.46,2.83,324.61,8.56,324.61,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M324.59,16.59c0,8-9.5,13.76-21.22,13.76s-21.22-5.75-21.22-13.76,8.9-13.75,21.31-13.75S324.59,8.57,324.59,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M324.57,16.58c0,8-9.49,13.76-21.2,13.76s-21.2-5.74-21.2-13.76,8.88-13.73,21.28-13.73S324.57,8.57,324.57,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M324.55,16.58c0,8-9.48,13.74-21.18,13.74s-21.18-5.73-21.18-13.74,8.87-13.72,21.25-13.72S324.55,8.58,324.55,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M324.53,16.58c0,8-9.48,13.73-21.16,13.73s-21.16-5.73-21.16-13.73,8.85-13.71,21.22-13.71S324.53,8.59,324.53,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M324.5,16.58c0,8-9.46,13.71-21.13,13.71s-21.14-5.72-21.14-13.71,8.83-13.7,21.19-13.7S324.5,8.6,324.5,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M324.48,16.58c0,8-9.45,13.7-21.11,13.7s-21.12-5.72-21.12-13.7S291.07,2.9,303.42,2.9,324.48,8.6,324.48,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M324.46,16.58c0,8-9.44,13.68-21.1,13.68s-21.09-5.71-21.09-13.68,8.8-13.67,21.14-13.67S324.46,8.61,324.46,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M324.44,16.58c0,8-9.44,13.66-21.08,13.66s-21.07-5.7-21.07-13.66S291.08,2.92,303.4,2.92,324.44,8.62,324.44,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M324.42,16.58c0,8-9.43,13.65-21.06,13.65s-21.06-5.7-21.06-13.65,8.78-13.65,21.09-13.65S324.42,8.62,324.42,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M324.4,16.58c0,7.94-9.42,13.63-21,13.63s-21-5.69-21-13.63,8.77-13.64,21.07-13.64S324.4,8.63,324.4,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M324.38,16.57c0,7.94-9.41,13.63-21,13.63s-21-5.69-21-13.63S291.09,3,303.38,3,324.38,8.64,324.38,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M324.36,16.57c0,7.93-9.41,13.61-21,13.61s-21-5.68-21-13.61S291.09,3,303.37,3,324.36,8.64,324.36,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M324.33,16.57c0,7.92-9.39,13.6-21,13.6s-21-5.68-21-13.6S291.1,3,303.36,3,324.33,8.65,324.33,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M324.31,16.57c0,7.91-9.38,13.58-20.95,13.58s-21-5.67-21-13.58S291.1,3,303.36,3,324.31,8.66,324.31,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M324.31,16.57c0,7.91-9.38,13.58-20.95,13.58s-21-5.67-21-13.58S291.1,3,303.36,3,324.31,8.66,324.31,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M324.18,16.57c0,7.89-9.35,13.54-20.87,13.54s-20.86-5.65-20.86-13.54S291.11,3,303.31,3,324.18,8.68,324.18,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M324,16.57c0,7.86-9.3,13.5-20.77,13.5s-20.78-5.64-20.78-13.5,8.63-13.5,20.78-13.5S324,8.71,324,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M323.91,16.57c0,7.84-9.27,13.45-20.69,13.45s-20.68-5.61-20.68-13.45,8.58-13.45,20.68-13.45S323.91,8.73,323.91,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M323.77,16.57c0,7.81-9.22,13.41-20.59,13.41s-20.6-5.6-20.6-13.41,8.55-13.41,20.6-13.41S323.77,8.76,323.77,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M323.64,16.57c0,7.78-9.18,13.36-20.51,13.36s-20.5-5.58-20.5-13.36S291.14,3.2,303.13,3.2,323.64,8.78,323.64,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M323.5,16.57c0,7.76-9.14,13.32-20.41,13.32s-20.42-5.56-20.42-13.32,8.48-13.33,20.42-13.33S323.5,8.81,323.5,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M323.37,16.57c0,7.74-9.1,13.28-20.33,13.28s-20.32-5.54-20.32-13.28S291.16,3.29,303,3.29,323.37,8.83,323.37,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M323.23,16.57c0,7.71-9.06,13.24-20.23,13.24s-20.24-5.53-20.24-13.24S291.16,3.33,303,3.33,323.23,8.86,323.23,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M323.1,16.57c0,7.68-9,13.19-20.15,13.19s-20.14-5.51-20.14-13.19S291.17,3.37,303,3.37,323.1,8.88,323.1,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M323,16.57c0,7.66-9,13.15-20,13.15s-20.06-5.49-20.06-13.15,8.33-13.15,20.06-13.15S323,8.91,323,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M322.83,16.57c0,7.63-8.94,13.11-20,13.11s-20-5.48-20-13.11,8.29-13.11,20-13.11S322.83,8.93,322.83,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M322.69,16.57c0,7.61-8.9,13.06-19.87,13.06s-19.88-5.45-19.88-13.06S291.19,3.5,302.82,3.5,322.69,9,322.69,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M322.55,16.57c0,7.58-8.85,13-19.78,13S283,24.15,283,16.57s8.21-13,19.78-13S322.55,9,322.55,16.57Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-234",
    cx: 302.72,
    cy: 16.57,
    rx: 19.69,
    ry: 12.98
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-235",
    cx: 302.68,
    cy: 16.57,
    rx: 19.6,
    ry: 12.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M322.15,16.57c0,7.51-8.74,12.89-19.52,12.89s-19.51-5.38-19.51-12.89,8.1-12.9,19.51-12.9S322.15,9.06,322.15,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M322,16.57c0,7.48-8.69,12.85-19.42,12.85s-19.43-5.37-19.43-12.85,8.07-12.85,19.43-12.85S322,9.08,322,16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M321.88,16.56c0,7.47-8.66,12.81-19.33,12.81S283.21,24,283.21,16.56s8-12.8,19.34-12.8S321.88,9.11,321.88,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M321.74,16.56c0,7.44-8.61,12.77-19.24,12.77S283.25,24,283.25,16.56s8-12.76,19.25-12.76S321.74,9.13,321.74,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M321.61,16.56c0,7.42-8.58,12.73-19.15,12.73S283.3,24,283.3,16.56s7.95-12.72,19.16-12.72S321.61,9.16,321.61,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M321.47,16.56c0,7.39-8.53,12.68-19.06,12.68S283.35,24,283.35,16.56s7.91-12.67,19.06-12.67S321.47,9.18,321.47,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M321.34,16.56c0,7.36-8.5,12.64-19,12.64s-19-5.28-19-12.64,7.88-12.63,19-12.63S321.34,9.2,321.34,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M321.2,16.56c0,7.34-8.45,12.59-18.88,12.59s-18.88-5.25-18.88-12.59S291.28,4,302.32,4,321.2,9.23,321.2,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M321.07,16.56c0,7.31-8.42,12.55-18.8,12.55s-18.79-5.24-18.79-12.55S291.28,4,302.27,4,321.07,9.26,321.07,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M320.93,16.56c0,7.29-8.37,12.51-18.7,12.51s-18.7-5.22-18.7-12.51,7.76-12.5,18.7-12.5S320.93,9.28,320.93,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M320.8,16.56c0,7.26-8.34,12.47-18.62,12.47s-18.61-5.21-18.61-12.47S291.3,4.1,302.18,4.1,320.8,9.3,320.8,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M320.66,16.56c0,7.24-8.29,12.42-18.52,12.42s-18.52-5.18-18.52-12.42,7.69-12.41,18.52-12.41S320.66,9.33,320.66,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M320.53,16.56c0,7.21-8.26,12.38-18.44,12.38s-18.43-5.17-18.43-12.38,7.65-12.37,18.43-12.37S320.53,9.36,320.53,16.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-249",
    cx: 302.05,
    cy: 16.56,
    rx: 18.34,
    ry: 12.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M320.26,16.56c0,7.16-8.18,12.29-18.26,12.29s-18.25-5.13-18.25-12.29S291.33,4.27,302,4.27,320.26,9.41,320.26,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M320.12,16.56c0,7.14-8.13,12.25-18.16,12.25S283.8,23.7,283.8,16.56,291.34,4.32,302,4.32,320.12,9.43,320.12,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M320,16.56c0,7.11-8.1,12.2-18.08,12.2s-18.07-5.09-18.07-12.2,7.5-12.2,18.07-12.2S320,9.45,320,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M319.85,16.56c0,7.09-8.05,12.16-18,12.16s-18-5.07-18-12.16,7.46-12.16,18-12.16S319.85,9.48,319.85,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M319.71,16.56c0,7.06-8,12.12-17.89,12.12s-17.89-5.06-17.89-12.12,7.43-12.11,17.89-12.11S319.71,9.5,319.71,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M319.58,16.56c0,7-8,12.08-17.8,12.08S284,23.59,284,16.56s7.4-12.07,17.81-12.07S319.58,9.53,319.58,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M319.44,16.56c0,7-7.93,12-17.71,12s-17.71-5-17.71-12,7.35-12,17.71-12S319.44,9.55,319.44,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M319.31,16.56c0,7-7.89,12-17.62,12s-17.63-5-17.63-12,7.32-12,17.63-12S319.31,9.58,319.31,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M319.17,16.56c0,7-7.85,11.94-17.53,11.94s-17.53-5-17.53-11.94,7.28-11.94,17.53-11.94S319.17,9.6,319.17,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M319,16.56c0,6.93-7.81,11.9-17.44,11.9s-17.44-5-17.44-11.9,7.24-11.9,17.44-11.9S319,9.63,319,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M318.9,16.56c0,6.91-7.76,11.86-17.35,11.86s-17.35-5-17.35-11.86S291.41,4.7,301.55,4.7,318.9,9.66,318.9,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M318.77,16.56c0,6.88-7.73,11.81-17.26,11.81s-17.26-4.93-17.26-11.81,7.16-11.81,17.26-11.81S318.77,9.68,318.77,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M318.63,16.56c0,6.86-7.68,11.77-17.17,11.77s-17.17-4.91-17.17-11.77,7.13-11.77,17.17-11.77S318.63,9.7,318.63,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M318.5,16.56c0,6.83-7.65,11.73-17.08,11.73s-17.08-4.9-17.08-11.73,7.09-11.73,17.08-11.73S318.5,9.73,318.5,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M318.36,16.56c0,6.81-7.6,11.68-17,11.68s-17-4.87-17-11.68,7.06-11.69,17-11.69S318.36,9.75,318.36,16.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-265",
    cx: 301.33,
    cy: 16.56,
    rx: 16.9,
    ry: 11.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-266",
    cx: 301.28,
    cy: 16.56,
    rx: 16.81,
    ry: 11.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M318,16.56c0,6.73-7.49,11.55-16.72,11.55s-16.72-4.82-16.72-11.55S291.46,5,301.24,5,318,9.83,318,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M317.82,16.56c0,6.7-7.44,11.51-16.63,11.51s-16.63-4.81-16.63-11.51,6.91-11.51,16.63-11.51S317.82,9.85,317.82,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M317.69,16.56c0,6.68-7.41,11.47-16.54,11.47s-16.54-4.79-16.54-11.47,6.86-11.47,16.54-11.47S317.69,9.88,317.69,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M317.55,16.56c0,6.66-7.36,11.42-16.45,11.42s-16.45-4.76-16.45-11.42S291.48,5.13,301.1,5.13,317.55,9.9,317.55,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M317.42,16.56c0,6.63-7.33,11.38-16.36,11.38S284.7,23.19,284.7,16.56s6.79-11.39,16.36-11.39S317.42,9.93,317.42,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M317.28,16.56c0,6.6-7.28,11.34-16.27,11.34s-16.27-4.74-16.27-11.34S291.5,5.22,301,5.22,317.28,10,317.28,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M317.15,16.56c0,6.58-7.25,11.29-16.18,11.29s-16.19-4.71-16.19-11.29S291.5,5.26,301,5.26,317.15,10,317.15,16.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-274",
    cx: 300.92,
    cy: 16.56,
    rx: 16.09,
    ry: 11.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M316.88,16.56c0,6.53-7.17,11.21-16,11.21s-16-4.68-16-11.21,6.64-11.21,16-11.21S316.88,10,316.88,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M316.74,16.56c0,6.5-7.12,11.16-15.91,11.16s-15.91-4.66-15.91-11.16,6.61-11.17,15.91-11.17S316.74,10.05,316.74,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M316.61,16.56c0,6.48-7.09,11.12-15.82,11.12S285,23,285,16.56s6.56-11.13,15.82-11.13S316.61,10.08,316.61,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M316.47,16.56c0,6.45-7,11.08-15.73,11.08S285,23,285,16.56s6.53-11.08,15.73-11.08S316.47,10.1,316.47,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M316.33,16.56c0,6.43-7,11-15.63,11s-15.65-4.61-15.65-11,6.5-11,15.65-11S316.33,10.13,316.33,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M316.2,16.56c0,6.4-7,11-15.55,11S285.1,23,285.1,16.56s6.46-11,15.55-11S316.2,10.15,316.2,16.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-281",
    cx: 300.6,
    cy: 16.56,
    rx: 15.46,
    ry: 10.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M315.93,16.56c0,6.35-6.88,10.9-15.37,10.9s-15.37-4.55-15.37-10.9,6.38-10.91,15.37-10.91S315.93,10.2,315.93,16.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-283",
    cx: 300.51,
    cy: 16.56,
    rx: 15.28,
    ry: 10.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M315.66,16.56c0,6.3-6.8,10.82-15.19,10.82s-15.19-4.52-15.19-10.82,6.31-10.83,15.19-10.83S315.66,10.25,315.66,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M315.52,16.56c0,6.27-6.76,10.77-15.1,10.77s-15.09-4.5-15.09-10.77,6.26-10.79,15.09-10.79S315.52,10.28,315.52,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M315.39,16.56c0,6.25-6.72,10.73-15,10.73s-15-4.48-15-10.73,6.23-10.74,15-10.74S315.39,10.3,315.39,16.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M315.25,16.55c0,6.23-6.68,10.7-14.92,10.7s-14.91-4.47-14.91-10.7,6.19-10.69,14.91-10.69S315.25,10.33,315.25,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M315.12,16.55c0,6.21-6.64,10.65-14.83,10.65s-14.83-4.44-14.83-10.65S291.62,5.9,300.29,5.9,315.12,10.35,315.12,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M315,16.55c0,6.18-6.6,10.61-14.74,10.61S285.5,22.73,285.5,16.55,291.62,6,300.24,6,315,10.37,315,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M314.85,16.55c0,6.16-6.56,10.57-14.65,10.57s-14.65-4.41-14.65-10.57S291.63,6,300.2,6,314.85,10.4,314.85,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M314.71,16.55c0,6.13-6.52,10.52-14.56,10.52s-14.56-4.39-14.56-10.52S291.64,6,300.15,6,314.71,10.42,314.71,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M314.58,16.55c0,6.11-6.48,10.48-14.47,10.48s-14.47-4.37-14.47-10.48,6-10.47,14.47-10.47S314.58,10.45,314.58,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M314.44,16.55C314.44,22.63,308,27,300.06,27s-14.37-4.36-14.37-10.44,6-10.43,14.37-10.43S314.44,10.48,314.44,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M314.3,16.55c0,6.06-6.39,10.39-14.28,10.39s-14.29-4.33-14.29-10.39S291.66,6.16,300,6.16,314.3,10.5,314.3,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M314.17,16.55c0,6-6.35,10.35-14.2,10.35s-14.19-4.32-14.19-10.35S291.67,6.2,300,6.2,314.17,10.53,314.17,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M314,16.55c0,6-6.32,10.31-14.11,10.31s-14.11-4.3-14.11-10.31,5.86-10.3,14.11-10.3S314,10.55,314,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M313.9,16.55c0,6-6.27,10.26-14,10.26s-14-4.28-14-10.26,5.82-10.26,14-10.26S313.9,10.58,313.9,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M313.76,16.55c0,5.95-6.23,10.22-13.92,10.22s-13.93-4.27-13.93-10.22,5.78-10.22,13.93-10.22S313.76,10.6,313.76,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M313.63,16.55c0,5.93-6.2,10.18-13.84,10.18S286,22.48,286,16.55,291.7,6.38,299.79,6.38,313.63,10.62,313.63,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M313.49,16.55c0,5.9-6.15,10.13-13.74,10.13S286,22.45,286,16.55s5.71-10.13,13.75-10.13S313.49,10.65,313.49,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M313.36,16.55c0,5.88-6.12,10.09-13.66,10.09S286,22.43,286,16.55,291.72,6.46,299.7,6.46,313.36,10.67,313.36,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M313.22,16.55c0,5.85-6.07,10.05-13.56,10.05s-13.57-4.2-13.57-10,5.63-10,13.57-10S313.22,10.7,313.22,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M313.09,16.55c0,5.83-6,10-13.48,10s-13.47-4.17-13.47-10,5.59-10,13.47-10S313.09,10.72,313.09,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M313,16.55c0,5.8-6,10-13.38,10s-13.39-4.16-13.39-10,5.56-10,13.39-10S313,10.75,313,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M312.82,16.55c0,5.78-5.95,9.92-13.3,9.92s-13.29-4.14-13.29-9.92,5.52-9.92,13.29-9.92S312.82,10.77,312.82,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M312.68,16.55c0,5.75-5.91,9.87-13.2,9.87s-13.21-4.12-13.21-9.87,5.48-9.87,13.21-9.87S312.68,10.8,312.68,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M312.55,16.55c0,5.73-5.87,9.83-13.12,9.83s-13.12-4.1-13.12-9.83,5.45-9.83,13.12-9.83S312.55,10.82,312.55,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M312.41,16.55c0,5.7-5.83,9.79-13,9.79s-13-4.09-13-9.79,5.41-9.79,13-9.79S312.41,10.85,312.41,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M312.28,16.55c0,5.68-5.79,9.74-12.94,9.74s-12.93-4.06-12.93-9.74,5.37-9.75,12.93-9.75S312.28,10.87,312.28,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M312.14,16.55c0,5.65-5.75,9.7-12.84,9.7s-12.85-4.05-12.85-9.7,5.33-9.7,12.85-9.7S312.14,10.9,312.14,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M312,16.55c0,5.62-5.71,9.66-12.76,9.66s-12.75-4-12.75-9.66,5.29-9.66,12.75-9.66S312,10.92,312,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M311.87,16.55c0,5.6-5.67,9.61-12.66,9.61s-12.67-4-12.67-9.61,5.26-9.62,12.67-9.62S311.87,11,311.87,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M311.74,16.55c0,5.57-5.63,9.57-12.58,9.57s-12.57-4-12.57-9.57S291.81,7,299.16,7,311.74,11,311.74,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M311.6,16.55c0,5.55-5.59,9.53-12.48,9.53s-12.49-4-12.49-9.53S291.81,7,299.12,7,311.6,11,311.6,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M311.47,16.55c0,5.52-5.55,9.48-12.4,9.48s-12.4-4-12.4-9.48,5.15-9.49,12.4-9.49S311.47,11,311.47,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M311.33,16.55c0,5.5-5.51,9.44-12.3,9.44s-12.31-3.94-12.31-9.44S291.83,7.11,299,7.11,311.33,11.05,311.33,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M311.2,16.55C311.2,22,305.73,26,299,26s-12.22-3.93-12.22-9.4,5.08-9.4,12.22-9.4S311.2,11.07,311.2,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M311.06,16.55c0,5.45-5.43,9.35-12.13,9.35s-12.12-3.9-12.12-9.35,5-9.36,12.12-9.36S311.06,11.1,311.06,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M310.92,16.55c0,5.42-5.38,9.31-12,9.31s-12-3.89-12-9.31,5-9.32,12-9.32S310.92,11.12,310.92,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M310.79,16.55c0,5.4-5.35,9.27-11.94,9.27s-12-3.87-12-9.27,5-9.27,12-9.27S310.79,11.15,310.79,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M310.65,16.55c0,5.37-5.3,9.22-11.85,9.22S287,21.92,287,16.55s4.92-9.23,11.85-9.23S310.65,11.17,310.65,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M310.52,16.55c0,5.35-5.27,9.18-11.76,9.18S287,21.9,287,16.55s4.89-9.19,11.77-9.19S310.52,11.2,310.52,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M310.39,16.55c0,5.32-5.23,9.14-11.68,9.14S287,21.87,287,16.55s4.85-9.14,11.68-9.14S310.39,11.22,310.39,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M310.25,16.55c0,5.29-5.19,9.09-11.58,9.09s-11.59-3.8-11.59-9.09,4.81-9.1,11.59-9.1S310.25,11.25,310.25,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M310.11,16.55c0,5.27-5.14,9.05-11.49,9.05s-11.5-3.78-11.5-9,4.78-9.06,11.5-9.06S310.11,11.27,310.11,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M310,16.55c0,5.24-5.11,9-11.4,9s-11.41-3.77-11.41-9,4.73-9,11.41-9S310,11.3,310,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M309.84,16.55c0,5.22-5.06,9-11.31,9s-11.32-3.74-11.32-9,4.7-9,11.32-9S309.84,11.32,309.84,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M309.71,16.55c0,5.19-5,8.92-11.23,8.92s-11.22-3.73-11.22-8.92,4.66-8.93,11.22-8.93S309.71,11.35,309.71,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M309.57,16.55c0,5.17-5,8.88-11.13,8.88s-11.13-3.71-11.13-8.88,4.62-8.89,11.13-8.89S309.57,11.37,309.57,16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M309.44,16.54c0,5.15-4.95,8.84-11.05,8.84s-11-3.69-11-8.84,4.59-8.83,11-8.83S309.44,11.4,309.44,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M309.3,16.54c0,5.13-4.9,8.8-10.95,8.8s-11-3.67-11-8.8,4.54-8.79,11-8.79S309.3,11.42,309.3,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M309.17,16.54c0,5.1-4.87,8.76-10.87,8.76s-10.86-3.66-10.86-8.76S292,7.79,298.3,7.79,309.17,11.45,309.17,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M309,16.54c0,5.08-4.82,8.71-10.77,8.71s-10.77-3.63-10.77-8.71S292,7.83,298.26,7.83,309,11.47,309,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M308.9,16.54c0,5.05-4.79,8.67-10.68,8.67s-10.69-3.62-10.69-8.67S292,7.88,298.22,7.88,308.9,11.5,308.9,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M308.76,16.54c0,5-4.74,8.62-10.59,8.62s-10.6-3.59-10.6-8.62,4.4-8.62,10.6-8.62S308.76,11.52,308.76,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M308.63,16.54c0,5-4.71,8.58-10.51,8.58s-10.5-3.58-10.5-8.58S292,8,298.12,8,308.63,11.55,308.63,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M308.49,16.54c0,5-4.66,8.54-10.41,8.54s-10.41-3.56-10.41-8.54S292,8,298.08,8,308.49,11.57,308.49,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M308.36,16.54c0,4.95-4.63,8.5-10.33,8.5s-10.32-3.55-10.32-8.5S292,8.05,298,8.05,308.36,11.59,308.36,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M308.22,16.54c0,4.92-4.58,8.45-10.23,8.45s-10.23-3.53-10.23-8.45S292,8.09,298,8.09,308.22,11.62,308.22,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M308.08,16.54c0,4.9-4.53,8.41-10.14,8.41s-10.14-3.51-10.14-8.41S292,8.13,297.94,8.13,308.08,11.65,308.08,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M308,16.54c0,4.87-4.5,8.37-10.05,8.37s-10.06-3.5-10.06-8.37S292,8.18,297.9,8.18,308,11.67,308,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M307.82,16.54c0,4.85-4.46,8.32-10,8.32s-10-3.47-10-8.32,4.14-8.32,10-8.32S307.82,11.7,307.82,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M307.68,16.54c0,4.82-4.42,8.28-9.87,8.28s-9.88-3.46-9.88-8.28,4.1-8.28,9.88-8.28S307.68,11.72,307.68,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M307.54,16.54c0,4.8-4.37,8.23-9.78,8.23S288,21.34,288,16.54s4.06-8.23,9.78-8.23S307.54,11.74,307.54,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M307.41,16.54c0,4.77-4.34,8.19-9.69,8.19s-9.7-3.42-9.7-8.19,4-8.19,9.7-8.19S307.41,11.77,307.41,16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M307.27,16.54c0,4.75-4.29,8.15-9.6,8.15s-9.6-3.4-9.6-8.15,4-8.15,9.6-8.15S307.27,11.79,307.27,16.54Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M304.49,6.17h0c-1.62,0-3,2.59-3.35,6.41.59-3.54,1.87-6,3.35-6h0c1.48,0,2.75,2.45,3.35,6C307.46,8.76,306.11,6.17,304.49,6.17Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M304.49,27.7h0c-1.5,0-2.93-3-3.47-7.12.39,4.26,1.75,7.49,3.43,7.54h.07c1.68-.05,3-3.28,3.44-7.54C307.42,24.68,306,27.7,304.49,27.7Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M315.5,4a36.54,36.54,0,0,0-22,0c-2.77.89-6.2,2.57-6.2,4.92,0,1.37,1.42,2.81,4.53,3.7-2.9-1-4.12-2.42-4.12-3.7,0-3.78,10.07-6.21,16.81-6.21s16.8,2.43,16.8,6.21c0,1.28-1.22,2.66-4.12,3.7,3.11-.89,4.53-2.33,4.53-3.7C321.7,6.53,318.28,4.85,315.5,4Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M327.18,17.92c0-2.79-1.09-5.27-3.41-8.25a13.44,13.44,0,0,1,3,8.25c0,8.51-9.46,15.11-22.28,15.11s-22.28-6.6-22.28-15.11a13.38,13.38,0,0,1,3-8.25c-2.33,3-3.42,5.46-3.42,8.25,0,8.79,9.82,15.53,22.69,15.53h0C317.36,33.45,327.18,26.71,327.18,17.92Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M6.69,48.36a3.33,3.33,0,0,1-1.13,1,3.62,3.62,0,0,1-1.68.37,4.11,4.11,0,0,1-1.55-.29,3.6,3.6,0,0,1-2-2A4.22,4.22,0,0,1,0,45.81a4,4,0,0,1,.3-1.57A3.37,3.37,0,0,1,1.12,43a3.71,3.71,0,0,1,1.24-.79A4.21,4.21,0,0,1,3.93,42a4,4,0,0,1,.76.07,3.62,3.62,0,0,1,.73.22,3.12,3.12,0,0,1,.65.36,2.37,2.37,0,0,1,.5.5l-.81.62A2,2,0,0,0,5,43.1a2.39,2.39,0,0,0-1.06-.24,2.75,2.75,0,0,0-1.17.23,2.81,2.81,0,0,0-.88.64,3,3,0,0,0-.56.94,3.33,3.33,0,0,0-.2,1.14A3.42,3.42,0,0,0,1.32,47a2.84,2.84,0,0,0,.55.94,2.5,2.5,0,0,0,.87.63,2.88,2.88,0,0,0,1.15.23A2.51,2.51,0,0,0,5,48.53a2.19,2.19,0,0,0,.84-.73Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M11.48,48.59h3.86v.92H10.45V42.14h4.73V43h-3.7v2.21H15v.89H11.48Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M20.45,49.51h-1V42.14h2.36a4.12,4.12,0,0,1,1,.11,2.44,2.44,0,0,1,.84.35,1.73,1.73,0,0,1,.57.63,2,2,0,0,1,.21,1,1.78,1.78,0,0,1-.5,1.31,2.39,2.39,0,0,1-1.3.64l2.07,3.38H23.43l-1.88-3.28h-1.1Zm0-4.14h1.19a3.53,3.53,0,0,0,.67-.07,1.79,1.79,0,0,0,.55-.2,1.06,1.06,0,0,0,.37-.36,1.27,1.27,0,0,0,0-1.12,1,1,0,0,0-.36-.36,1.58,1.58,0,0,0-.53-.19,3.21,3.21,0,0,0-.63-.06H20.45Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M31,49.51h-1V43H27.58v-.9h5.76V43H31Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M38.06,49.51H37V42.14h1Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M43.58,49.51h-1V42.14h4.61V43H43.58v2.29h3.35v.89H43.58Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M52.21,49.51h-1V42.14h1Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M57.73,48.59h3.86v.92H56.7V42.14h4.73V43h-3.7v2.21h3.48v.89H57.73Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M65.67,42.14H68.2a4.92,4.92,0,0,1,1.41.21A3.65,3.65,0,0,1,70.9,43a3.28,3.28,0,0,1,.92,1.15,3.58,3.58,0,0,1,.36,1.67,3.48,3.48,0,0,1-.36,1.64,3.37,3.37,0,0,1-.92,1.15,4.09,4.09,0,0,1-1.29.68,4.93,4.93,0,0,1-1.41.22H65.67Zm1,6.46H68a4,4,0,0,0,1.23-.18,2.84,2.84,0,0,0,1-.55,2.24,2.24,0,0,0,.64-.87,2.79,2.79,0,0,0,.23-1.18,2.83,2.83,0,0,0-.23-1.2,2.24,2.24,0,0,0-.64-.87,2.65,2.65,0,0,0-1-.53A3.73,3.73,0,0,0,68,43H66.7Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M81.61,42.14h2.25a4.58,4.58,0,0,1,1.08.12,2.26,2.26,0,0,1,.83.37,1.62,1.62,0,0,1,.53.63,2.06,2.06,0,0,1,.19.93,2.15,2.15,0,0,1-.2,1,1.73,1.73,0,0,1-.56.64,2.49,2.49,0,0,1-.86.37,4.47,4.47,0,0,1-1.06.12H82.64v3.24h-1Zm1,3.26h1.09a3.86,3.86,0,0,0,.7-.07,1.9,1.9,0,0,0,.54-.21,1.06,1.06,0,0,0,.36-.37,1.19,1.19,0,0,0,.12-.56,1.08,1.08,0,0,0-.13-.56,1,1,0,0,0-.35-.36,1.45,1.45,0,0,0-.54-.2,3.58,3.58,0,0,0-.68-.06H82.64Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M91.54,49.51h-1V42.14h2.36a4.06,4.06,0,0,1,1,.11,2.44,2.44,0,0,1,.84.35,1.73,1.73,0,0,1,.57.63,2,2,0,0,1,.21,1,1.78,1.78,0,0,1-.5,1.31,2.33,2.33,0,0,1-1.29.64l2.06,3.38H94.52l-1.87-3.28H91.54Zm0-4.14h1.19a3.64,3.64,0,0,0,.68-.07,1.73,1.73,0,0,0,.54-.2,1.06,1.06,0,0,0,.37-.36,1.19,1.19,0,0,0,0-1.12,1,1,0,0,0-.36-.36,1.6,1.6,0,0,0-.52-.19A3.31,3.31,0,0,0,92.8,43H91.54Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M100.64,48.59h3.85v.92H99.61V42.14h4.73V43h-3.7v2.21h3.48v.89h-3.48Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M110.55,47.39h-2.41v-.83h2.41Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M122.05,45.81a4,4,0,0,1-.3,1.57,3.63,3.63,0,0,1-.82,1.23,3.69,3.69,0,0,1-1.23.8,4.22,4.22,0,0,1-1.57.29,4.11,4.11,0,0,1-1.55-.29,3.57,3.57,0,0,1-2-2,4.39,4.39,0,0,1,0-3.14,3.62,3.62,0,0,1,.81-1.22,3.71,3.71,0,0,1,1.24-.79,4.11,4.11,0,0,1,1.55-.28,4.21,4.21,0,0,1,1.57.28,3.66,3.66,0,0,1,1.23.79,3.5,3.5,0,0,1,.82,1.22A4,4,0,0,1,122.05,45.81Zm-1.12,0a3.33,3.33,0,0,0-.19-1.14,3,3,0,0,0-.57-.94,2.6,2.6,0,0,0-.88-.64,3,3,0,0,0-2.31,0,2.66,2.66,0,0,0-.87.64,3,3,0,0,0-.56.94,3.33,3.33,0,0,0-.2,1.14,3.41,3.41,0,0,0,.2,1.16,2.86,2.86,0,0,0,.56.94,2.63,2.63,0,0,0,.88.63,2.8,2.8,0,0,0,1.14.23,2.89,2.89,0,0,0,1.16-.23,2.45,2.45,0,0,0,.88-.63,2.89,2.89,0,0,0,.57-.94A3.4,3.4,0,0,0,120.93,45.81Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M128.11,48h0l1.73-5.87H131L132.71,48h0l1.63-5.87h1.09l-2.17,7.37h-1.07l-1.79-5.93h0l-1.79,5.93h-1.07l-2.17-7.37h1.11Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M144.35,48h0V42.14h1v7.37h-1.3l-3.89-6h0v6h-1V42.14h1.34Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M150.93,48.59h3.85v.92H149.9V42.14h4.73V43h-3.7v2.21h3.48v.89h-3.48Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M158.87,42.14h2.53a4.92,4.92,0,0,1,1.41.21,3.61,3.61,0,0,1,1.28.65,3.42,3.42,0,0,1,.93,1.15,3.71,3.71,0,0,1,.35,1.67,3.61,3.61,0,0,1-.35,1.64,3.52,3.52,0,0,1-.93,1.15,4,4,0,0,1-1.28.68,4.93,4.93,0,0,1-1.41.22h-2.53Zm1,6.46h1.29a4.06,4.06,0,0,0,1.23-.18,2.84,2.84,0,0,0,1-.55A2.35,2.35,0,0,0,164,47a3,3,0,0,0,.23-1.18,3,3,0,0,0-.23-1.2,2.35,2.35,0,0,0-.64-.87,2.65,2.65,0,0,0-1-.53,3.78,3.78,0,0,0-1.23-.19H159.9Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M177.07,48.18h0l2.21-6h1.12l-2.9,7.37h-.95l-2.88-7.37h1.15Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M185,48.59h3.85v.92H184V42.14h4.73V43H185v2.21h3.48v.89H185Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M193,42.14h1v3.08h3.72V42.14h1v7.37h-1V46.14H194v3.37h-1Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M204.3,49.51h-1V42.14h1Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M215.12,48.36a3.33,3.33,0,0,1-1.13,1,3.65,3.65,0,0,1-1.68.37,4.2,4.2,0,0,1-1.56-.29,3.79,3.79,0,0,1-1.23-.8,3.59,3.59,0,0,1-.8-1.23,4,4,0,0,1-.29-1.57,4.18,4.18,0,0,1,.29-1.57,3.39,3.39,0,0,1,.83-1.22,3.71,3.71,0,0,1,1.24-.79,4.2,4.2,0,0,1,1.56-.28,4,4,0,0,1,.76.07,3.71,3.71,0,0,1,.74.22,3.39,3.39,0,0,1,.65.36,2.37,2.37,0,0,1,.5.5l-.82.62a2,2,0,0,0-.76-.62,2.43,2.43,0,0,0-1.07-.24,2.64,2.64,0,0,0-2,.87,3,3,0,0,0-.56.94,3.33,3.33,0,0,0-.2,1.14,3.42,3.42,0,0,0,.19,1.17,2.86,2.86,0,0,0,.56.94,2.41,2.41,0,0,0,.87.63,2.84,2.84,0,0,0,1.15.23,2.54,2.54,0,0,0,1.14-.25,2.19,2.19,0,0,0,.84-.73Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M219.91,48.59h3.29v.92h-4.32V42.14h1Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M227.94,48.59h3.85v.92h-4.88V42.14h4.72V43h-3.69v2.21h3.48v.89h-3.48Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M239.54,43.5a1.72,1.72,0,0,0-.6-.49,1.8,1.8,0,0,0-.84-.2,2.15,2.15,0,0,0-.5.07,1.45,1.45,0,0,0-.47.22,1.24,1.24,0,0,0-.34.38,1.06,1.06,0,0,0-.13.53,1,1,0,0,0,.12.51,1.07,1.07,0,0,0,.33.34,2.29,2.29,0,0,0,.47.24l.59.2.76.26a2.8,2.8,0,0,1,.7.39,1.85,1.85,0,0,1,.51.6,1.89,1.89,0,0,1,.2.91,2,2,0,0,1-.78,1.69,2.53,2.53,0,0,1-.82.41,3.41,3.41,0,0,1-1,.14,3.46,3.46,0,0,1-1.35-.27,2.71,2.71,0,0,1-1.08-.81l.8-.67a2.1,2.1,0,0,0,.7.62,1.94,1.94,0,0,0,.95.24,1.86,1.86,0,0,0,.52-.07,1.58,1.58,0,0,0,.47-.23,1.2,1.2,0,0,0,.35-.39,1.15,1.15,0,0,0,.14-.57,1,1,0,0,0-.14-.55,1.41,1.41,0,0,0-.38-.39,2.64,2.64,0,0,0-.56-.26l-.67-.22a5.89,5.89,0,0,1-.7-.26,2.27,2.27,0,0,1-.61-.39,1.68,1.68,0,0,1-.44-.57,2,2,0,0,1-.17-.86,1.87,1.87,0,0,1,.23-.94,1.85,1.85,0,0,1,.58-.66,2.51,2.51,0,0,1,.81-.38,3.56,3.56,0,0,1,.91-.12,3.22,3.22,0,0,1,1.21.23,2.51,2.51,0,0,1,.91.61Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-349",
    x1: 256.95,
    x2: 256.95,
    y2: 49.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRed);
export default __webpack_public_path__ + "static/media/logo-red.517a02e6c80f0a44623ffd03e9231a96.svg";
export { ForwardRef as ReactComponent };